import React, { useEffect, useState, useMemo, useRef } from 'react';
import { Bar, Line, Pie, PolarArea, Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, PointElement, LineElement, RadialLinearScale } from 'chart.js';
import { dotoniwoofApi } from '../api/dotoniwooApi';
import { getExpenseReport, getExpenseReportDay, getExpenseReportCategory } from '../services/expenseApi';
import {
  getPurchaseReportMonth,
  getPurchaseReport,
  getPurchaseReportPending,
  getPurchaseReportOverdue,
  getPurchaseReportTerm,
  getPurchaseReportDueSoon
} from '../services/purchaseApi';
import { Col, Container, Row, Card, Form, Spinner, Alert } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { useBranding } from '../context/BrandingContext';
import './ModernDashboard.css';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, PointElement, LineElement, RadialLinearScale);

const MONTH_LABELS = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

const CRECIMIENTO_ANUAL = 0.55; // 55% de incremento anual

const ModernDashboard = () => {
    const [salesData, setSalesData] = useState({
        labels: [],
        datasets: [],
    });

    const [salesDataDay, setSalesDataDay] = useState({
        labels: [],
        datasets: [],
    });

    const [salesDataItemsFood, setSalesDataItemsFood] = useState({
        labels: [],
        datasets: [],
    });

    const [salesDataCategory, setSalesDataCategory] = useState({
        labels: [],
        datasets: [],
    });

    const [expensesDataCategory, setExpensesDataCategory] = useState({
        labels: [],
        datasets: [],
    });

    // Nuevos estados para KPIs del día
    const [todaySalesValue, setTodaySalesValue] = useState(0);
    const [todayCategoryData, setTodayCategoryData] = useState({
        labels: ['Cargando...'],
        datasets: [{
            label: 'Ventas del Día ($)',
            data: [0],
            backgroundColor: ['rgba(234, 157, 14, 0.2)'],
            borderColor: ['#EA9D0E'],
            borderWidth: 2,
            borderRadius: 8,
            borderSkipped: false,
        }]
    });
    const [kpiData, setKpiData] = useState({
        ticketPromedio: 0,
        totalTransacciones: 0,
        ventasVsDiaAnterior: 0,
        topProducto: 'Cargando...'
    });
    const [profitData, setProfitData] = useState({
        totalProfit: 0,
        totalSales: 0,
        avgProfit: 0
    });
    const [monthProfitData, setMonthProfitData] = useState({
        totalProfit: 0,
        totalSales: 0,
        avgProfitPerSale: 0,
        avgProfitPerDay: 0
    });
    const [monthExpensesTotal, setMonthExpensesTotal] = useState(0);
    const [monthPurchasesTotal, setMonthPurchasesTotal] = useState(0);
    const [monthPurchasesPending, setMonthPurchasesPending] = useState(0);
    const [monthPurchasesOverdue, setMonthPurchasesOverdue] = useState(0);
    const [purchasesVariationVsPrevious, setPurchasesVariationVsPrevious] = useState(null);
    const [purchaseReportByMonth, setPurchaseReportByMonth] = useState([]);
    const [purchaseTermReport, setPurchaseTermReport] = useState({
      items: [],
      summary: { grand_total: 0, total_purchases: 0 }
    });
    const [purchaseDueSoon, setPurchaseDueSoon] = useState({
      purchases: [],
      summary: { total_amount: 0, count: 0, days_window: 7 }
    });
    const [annualProfitByMonth, setAnnualProfitByMonth] = useState([]);
    const [annualSummaryLoading, setAnnualSummaryLoading] = useState(false);
    const annualProfitCacheRef = useRef({ year: null, profits: [] });
    const [prevYearSales, setPrevYearSales] = useState([]);
    const [paymentMethodData, setPaymentMethodData] = useState({
        labels: ['Cargando...'],
        datasets: [{
            data: [1],
            backgroundColor: ['rgba(234, 157, 14, 0.2)'],
            borderColor: ['#EA9D0E'],
            borderWidth: 2
        }],
        total: 0
    });

    const [groomingData, setGroomingData] = useState({
        labels: [],
        datasets: [],
    });

    const [profitByCategoryData, setProfitByCategoryData] = useState({
        labels: ['Cargando...'],
        datasets: [{
            label: 'Utilidad por Categoría',
            data: [0],
            backgroundColor: ['rgba(234, 157, 14, 0.2)'],
            borderColor: ['#EA9D0E'],
            borderWidth: 2,
            borderRadius: 8,
            borderSkipped: false,
        }]
    });

    const [profitByCategoryMonthlyData, setProfitByCategoryMonthlyData] = useState({
        labels: MONTH_LABELS,
        datasets: []
    });

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fechaActual = new Date();
    const year = fechaActual.getFullYear().toString();
    const month = fechaActual.getMonth();
    const [SelectedMonth, setSelectedMonth] = useState((month + 1).toString());
    const [SelectedYear, setSelectedYear] = useState(year);

    // Configuración desde branding
    const { colors, companyName } = useBranding();
    const brandColors = {
        primary: colors.primary,
        secondary: colors.accent,
        success: colors.success,
        warning: colors.warning,
        danger: colors.danger,
        info: colors.info
    };

    const hexToRgba = (hex, alpha) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };

    const chartColors = {
        sales: {
            background: hexToRgba(colors.secondary, 0.1),
            border: colors.secondary,
            hover: hexToRgba(colors.secondary, 0.2)
        },
        expenses: {
            background: hexToRgba(colors.danger, 0.1),
            border: colors.danger,
            hover: hexToRgba(colors.danger, 0.2)
        },
        category: [
            colors.secondary,
            colors.accent,
            colors.success,
            colors.warning,
            colors.danger,
            colors.info,
            '#6f42c1',
            '#fd7e14'
        ]
    };

    useEffect(() => {
        const fetchAllData = async () => {
            setLoading(true);
            setError(null);

            let labels = [];
            let sales = [];
            let expenses = [];

            try {
                const dataSale = await dotoniwoofApi.get(`/sale.php/sale-report?year=${SelectedYear}`);
                const msg = dataSale?.data?.message;
                if (msg && Array.isArray(msg) && msg[0]) {
                    labels = msg[0].months || [];
                    sales = Array.isArray(msg[0].sales) ? msg[0].sales : [];
                }
            } catch (err) {
                console.error('Error al cargar ventas anuales:', err);
                setError('Error al cargar datos de ventas anuales');
            }

            try {
                const dataExpenseResult = await getExpenseReport(SelectedYear);
                if (dataExpenseResult.ok && dataExpenseResult.data?.message?.[0]?.expenses) {
                    expenses = Array.isArray(dataExpenseResult.data.message[0].expenses)
                        ? dataExpenseResult.data.message[0].expenses
                        : [];
                }
            } catch (err) {
                console.error('Error al cargar gastos anuales:', err);
            }

            let purchasesByMonth = [];
            try {
                const purchaseReport = await getPurchaseReport(SelectedYear);
                if (purchaseReport.ok && Array.isArray(purchaseReport.purchases)) {
                    purchasesByMonth = purchaseReport.purchases;
                }
            } catch (err) {
                console.error('Error al cargar compras anuales:', err);
            }
            setPurchaseReportByMonth(purchasesByMonth);

            let prevSales = [];
            try {
                const prevYear = parseInt(SelectedYear, 10) - 1;
                const dataPrev = await dotoniwoofApi.get(`/sale.php/sale-report?year=${prevYear}`);
                const msgPrev = dataPrev?.data?.message;
                if (msgPrev && Array.isArray(msgPrev) && msgPrev[0]?.sales) {
                    prevSales = Array.isArray(msgPrev[0].sales) ? msgPrev[0].sales : [];
                }
            } catch (err) {
                console.error('Error al cargar ventas año anterior (meta):', err);
            }
            setPrevYearSales(prevSales);

            setSalesData({
                labels,
                datasets: [
                    {
                        label: 'Ventas ($)',
                        data: sales,
                        backgroundColor: chartColors.sales.background,
                        borderColor: chartColors.sales.border,
                        borderWidth: 2,
                        borderRadius: 6,
                        borderSkipped: false,
                    },
                    {
                        label: 'Gastos ($)',
                        data: expenses.length ? expenses : labels.map(() => 0),
                        backgroundColor: chartColors.expenses.background,
                        borderColor: chartColors.expenses.border,
                        borderWidth: 2,
                        borderRadius: 6,
                        borderSkipped: false,
                    },
                ],
            });
            setLoading(false);
        };

        fetchAllData();
    }, [SelectedYear]);

    useEffect(() => {
        const fetchSalesDataCategory = async () => {
            try {
                const data = await dotoniwoofApi.get(`/sale.php/sale-report-category?year=${SelectedYear}`);
                setSalesDataCategory({
                    labels: data.data.message[0].categories,
                    datasets: [{
                        label: 'Ventas ($)',
                        data: data.data.message[0].sales,
                        backgroundColor: chartColors.category,
                        borderColor: chartColors.category.map(color => color + '80'),
                        borderWidth: 2,
                        hoverOffset: 8
                    }]
                });
            } catch (err) {
                console.error('Error loading category data:', err);
            }
        };
        fetchSalesDataCategory();
    }, [SelectedYear]);

    useEffect(() => {
        const fetchExpensesDataCategory = async () => {
            try {
                const dataResult = await getExpenseReportCategory(SelectedMonth);
                const data = dataResult.ok && dataResult.data?.message?.[0] ? { data: dataResult.data } : { data: { message: [{ categories: [], expenses: [] }] } };
                setExpensesDataCategory({
                    labels: data.data.message[0].categories || [],
                    datasets: [{
                        label: 'Gastos ($)',
                        data: data.data.message[0].expenses || [],
                        backgroundColor: chartColors.category,
                        borderColor: chartColors.category.map(color => color + '80'),
                        borderWidth: 2,
                        hoverOffset: 8
                    }]
                });
            } catch (err) {
                console.error('Error loading expenses data:', err);
            }
        };
        fetchExpensesDataCategory();
    }, [SelectedMonth]);

    useEffect(() => {
        const fetchSalesDataDay = async () => {
            try {
                const [dataSale, dataExpenseResultDay] = await Promise.all([
                    dotoniwoofApi.get(`/sale.php/sale-report-day?month=${SelectedMonth}&year=${SelectedYear}`),
                    getExpenseReportDay(SelectedMonth, SelectedYear)
                ]);
                const dataExpenseDay = dataExpenseResultDay.ok ? { data: dataExpenseResultDay.data } : { data: { message: [{}] } };

                const expensesArr = (dataExpenseDay.data.message && dataExpenseDay.data.message[0] && dataExpenseDay.data.message[0].expenses) ? dataExpenseDay.data.message[0].expenses : [];
                const totalExpensesMonth = Array.isArray(expensesArr) ? expensesArr.reduce((s, v) => s + (Number(v) || 0), 0) : 0;
                setMonthExpensesTotal(totalExpensesMonth);

                setSalesDataDay({
                    labels: dataSale.data.message[0].days,
                    datasets: [
                        {
                            label: 'Ventas ($)',
                            data: dataSale.data.message[0].sales,
                            backgroundColor: chartColors.sales.background,
                            borderColor: chartColors.sales.border,
                            borderWidth: 2,
                            borderRadius: 6,
                            borderSkipped: false,
                        },
                        {
                            label: 'Gastos ($)',
                            data: (dataExpenseDay.data.message && dataExpenseDay.data.message[0] && dataExpenseDay.data.message[0].expenses) ? dataExpenseDay.data.message[0].expenses : [],
                            backgroundColor: chartColors.expenses.background,
                            borderColor: chartColors.expenses.border,
                            borderWidth: 2,
                            borderRadius: 6,
                            borderSkipped: false,
                        },
                    ],
                });
            } catch (err) {
                console.error('Error loading daily data:', err);
            }
        };
        fetchSalesDataDay();
    }, [SelectedMonth, SelectedYear]);

    useEffect(() => {
        const fetchSalesDataItemsFood = async () => {
            try {
                const data = await dotoniwoofApi.get(`/sale.php/sale-report-item-food?month=${SelectedMonth}`);
                setSalesDataItemsFood({
                    labels: data.data.message[0].products,
                    datasets: [
                        {
                            label: 'Ventas ($)',
                            data: data.data.message[0].sales,
                            backgroundColor: chartColors.sales.background,
                            borderColor: chartColors.sales.border,
                            borderWidth: 2,
                            borderRadius: 6,
                            borderSkipped: false,
                        },
                    ],
                });
            } catch (err) {
                console.error('Error loading food items data:', err);
            }
        };
        fetchSalesDataItemsFood();
    }, [SelectedMonth]);

    // Nuevo useEffect para obtener ventas del día actual
    useEffect(() => {
        const fetchTodaySales = async () => {
            try {
                // Obtener fecha local de Colombia (GMT-5)
                const today = new Date();
                const year = today.getFullYear();
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const day = String(today.getDate()).padStart(2, '0');
                const todayStr = `${year}-${month}-${day}`;
                
                console.log('🔄 Fetching today sales for date (Colombia GMT-5):', todayStr);
                
                // Endpoint: /sale.php/sale-today?date=YYYY-MM-DD
                const response = await dotoniwoofApi.get(`/sale.php/sale-today?date=${todayStr}`);
                
                console.log('✅ Today sales response:', response.data);
                
                // Response: { status: "ok", code: 200, message: "TOTAL DEL DÍA", date: "2025-10-20", total: 2000 }
                if (response.data && response.data.status === 'ok') {
                    console.log('💰 Setting today sales value:', response.data.total);
                    setTodaySalesValue(response.data.total || 0);
                } else {
                    console.warn('⚠️ Response status not ok:', response.data);
                }
            } catch (err) {
                console.error('❌ Error loading today sales:', err);
                console.error('Error details:', err.response?.data || err.message);
                // Mantener valor actual en caso de error
                setTodaySalesValue(0);
            }
        };
        fetchTodaySales();
    }, []); // Se ejecuta solo al montar el componente

    // Nuevo useEffect para obtener ventas por categoría del día
    useEffect(() => {
        const fetchTodayCategoryData = async () => {
            try {
                // Obtener fecha local de Colombia (GMT-5)
                const today = new Date();
                const year = today.getFullYear();
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const day = String(today.getDate()).padStart(2, '0');
                const todayStr = `${year}-${month}-${day}`;
                
                console.log('🔄 Fetching today category data for date (Colombia GMT-5):', todayStr);
                
                // Endpoint: /sale.php/sale-category-today?date=YYYY-MM-DD
                const response = await dotoniwoofApi.get(`/sale.php/sale-category-today?date=${todayStr}`);
                
                console.log('✅ Category response:', response.data);
                
                // Response: { status: "ok", code: 200, message: "VENTAS POR CATEGORÍA", date: "2025-10-20", categories: [{category: "Comida", total: 2000}] }
                if (response.data && response.data.status === 'ok' && response.data.categories) {
                    // Transformar array de objetos a formato de Chart.js
                    const labels = response.data.categories.map(item => item.category);
                    const data = response.data.categories.map(item => item.total);
                    
                    console.log('📊 Setting category data - labels:', labels, 'data:', data);
                    
                    setTodayCategoryData({
                        labels: labels,
                        datasets: [{
                            label: 'Ventas del Día ($)',
                            data: data,
                            backgroundColor: chartColors.category,
                            borderColor: chartColors.category.map(color => color + '80'),
                            borderWidth: 2,
                            borderRadius: 8,
                            borderSkipped: false,
                        }]
                    });
                } else {
                    console.warn('⚠️ Category response not valid:', response.data);
                }
            } catch (err) {
                console.error('❌ Error loading today category data:', err);
                console.error('Error details:', err.response?.data || err.message);
                // Datos de ejemplo mientras se implementa el backend
                setTodayCategoryData({
                    labels: ['Sin datos'],
                    datasets: [{
                        label: 'Ventas del Día ($)',
                        data: [0],
                        backgroundColor: chartColors.category,
                        borderColor: chartColors.category.map(color => color + '80'),
                        borderWidth: 2,
                        borderRadius: 8,
                        borderSkipped: false,
                    }]
                });
            }
        };
        fetchTodayCategoryData();
    }, []); // Se ejecuta solo al montar el componente

    // Nuevo useEffect para obtener KPIs del día
    useEffect(() => {
        const fetchKpiData = async () => {
            try {
                // Obtener fecha local de Colombia (GMT-5)
                const today = new Date();
                const year = today.getFullYear();
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const day = String(today.getDate()).padStart(2, '0');
                const todayStr = `${year}-${month}-${day}`;
                
                console.log('🔄 Fetching KPI data for date (Colombia GMT-5):', todayStr);
                
                // Endpoint: /sale.php/sale-kpi-today?date=YYYY-MM-DD
                const response = await dotoniwoofApi.get(`/sale.php/sale-kpi-today?date=${todayStr}`);
                
                console.log('✅ KPI response:', response.data);
                
                // Response: { status: "ok", code: 200, message: "KPIs DIARIOS", date: "2025-10-20", kpis: { total_sales: 2000, transactions: 1, avg_ticket: 2000, items_sold: 1, ventasVsDiaAnterior: 0, topProducto: {...} } }
                if (response.data && response.data.status === 'ok' && response.data.kpis) {
                    const kpis = response.data.kpis;
                    setKpiData({
                        ticketPromedio: kpis.avg_ticket || 0,
                        totalTransacciones: kpis.transactions || 0,
                        ventasVsDiaAnterior: kpis.ventasVsDiaAnterior || 0,
                        topProducto: kpis.topProducto?.name || 'Sin ventas'
                    });
                    console.log('📊 KPIs set:', {
                        ticketPromedio: kpis.avg_ticket,
                        totalTransacciones: kpis.transactions,
                        totalSales: kpis.total_sales,
                        itemsSold: kpis.items_sold,
                        ventasVsDiaAnterior: kpis.ventasVsDiaAnterior,
                        topProducto: kpis.topProducto
                    });
                }
            } catch (err) {
                console.error('❌ Error loading KPI data:', err);
                console.error('Error details:', err.response?.data || err.message);
            }
        };
        fetchKpiData();
    }, []); // Se ejecuta solo al montar el componente

    // Nuevo useEffect para obtener utilidad promedio del día
    useEffect(() => {
        const fetchProfitData = async () => {
            try {
                // Obtener fecha local de Colombia (GMT-5)
                const today = new Date();
                const year = today.getFullYear();
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const day = String(today.getDate()).padStart(2, '0');
                const todayStr = `${year}-${month}-${day}`;
                
                console.log('🔄 Fetching profit data for date (Colombia GMT-5):', todayStr);
                
                // Endpoint: /sale.php/sale-profit-today?date=YYYY-MM-DD
                const response = await dotoniwoofApi.get(`/sale.php/sale-profit-today?date=${todayStr}`);
                
                console.log('✅ Profit response:', response.data);
                
                // Response: { status: "ok", code: 200, message: "UTILIDAD PROMEDIO DEL DÍA", profit: { total_profit: 58300, total_sales: 12, avg_profit: 4858.33 } }
                if (response.data && response.data.status === 'ok' && response.data.profit) {
                    const profit = response.data.profit;
                    setProfitData({
                        totalProfit: profit.total_profit || 0,
                        totalSales: profit.total_sales || 0,
                        avgProfit: profit.avg_profit || 0
                    });
                    console.log('💰 Profit data set:', profit);
                }
            } catch (err) {
                console.error('❌ Error loading profit data:', err);
                console.error('Error details:', err.response?.data || err.message);
            }
        };
        fetchProfitData();
    }, []); // Se ejecuta solo al montar el componente

    // Nuevo useEffect para obtener utilidad del mes seleccionado
    useEffect(() => {
        const fetchMonthProfitData = async () => {
            try {
                // Formato YYYY-MM
                const monthStr = `${SelectedYear}-${SelectedMonth}`;
                
                console.log('🔄 Fetching month profit data for:', monthStr);
                
                // Endpoint: /sale.php/sale-profit-month?date=YYYY-MM
                const response = await dotoniwoofApi.get(`/sale.php/sale-profit-month?date=${monthStr}`);
                
                console.log('✅ Month profit response:', response.data);
                
                // Response: { status: "ok", code: 200, message: "UTILIDAD PROMEDIO DEL MES", month: "2025-10", profit: {...} }
                if (response.data && response.data.status === 'ok' && response.data.profit) {
                    const profit = response.data.profit;
                    setMonthProfitData({
                        totalProfit: profit.total_profit || 0,
                        totalSales: profit.total_sales || 0,
                        avgProfitPerSale: profit.avg_profit_per_sale || 0,
                        avgProfitPerDay: profit.avg_profit_per_day || 0
                    });
                    console.log('📅 Month profit data set:', profit);
                }
            } catch (err) {
                console.error('❌ Error loading month profit data:', err);
                console.error('Error details:', err.response?.data || err.message);
            }
        };
        fetchMonthProfitData();
    }, [SelectedMonth, SelectedYear]); // Se ejecuta cuando cambia el mes o año seleccionado

    // Compras: total mes, pendiente, vencido, variación vs mes anterior
    useEffect(() => {
        const fetchPurchasesData = async () => {
            try {
                const now = new Date();
                const year = now.getFullYear();
                const month = now.getMonth() + 1;

                const [monthRes, pendingRes, overdueRes, termRes, dueSoonRes] = await Promise.all([
                    getPurchaseReportMonth(year, month),
                    getPurchaseReportPending(),
                    getPurchaseReportOverdue(),
                    getPurchaseReportTerm(year, month),
                    getPurchaseReportDueSoon(7)
                ]);

                const currentTotal = monthRes.ok ? (monthRes.total || 0) : 0;
                setMonthPurchasesTotal(currentTotal);
                setMonthPurchasesPending(pendingRes.ok ? (pendingRes.total || 0) : 0);
                setMonthPurchasesOverdue(overdueRes.ok ? (overdueRes.total || 0) : 0);

                // Variación vs mes anterior
                let prevYear = year;
                let prevMonth = month - 1;
                if (prevMonth < 1) {
                    prevMonth = 12;
                    prevYear = year - 1;
                }
                const prevRes = await getPurchaseReportMonth(prevYear, prevMonth);
                const prevTotal = prevRes.ok ? (prevRes.total || 0) : 0;
                if (prevTotal > 0) {
                    const variation = ((currentTotal - prevTotal) / prevTotal) * 100;
                    setPurchasesVariationVsPrevious(variation);
                } else {
                    setPurchasesVariationVsPrevious(currentTotal > 0 ? 100 : 0);
                }

                if (termRes.ok) {
                    setPurchaseTermReport({
                        items: termRes.items || [],
                        summary: termRes.summary || { grand_total: 0, total_purchases: 0 }
                    });
                }
                if (dueSoonRes.ok) {
                    setPurchaseDueSoon({
                        purchases: dueSoonRes.purchases || [],
                        summary: dueSoonRes.summary || { total_amount: 0, count: 0, days_window: 7 }
                    });
                }
            } catch (err) {
                console.error('Error al cargar datos de compras:', err);
            }
        };
        fetchPurchasesData();
    }, []);

    // Obtener utilidad (profit) por mes del año: un solo endpoint sale-profit-year.
    useEffect(() => {
        const cache = annualProfitCacheRef.current;
        if (cache.year === SelectedYear && Array.isArray(cache.profits) && cache.profits.length === 12) {
            setAnnualProfitByMonth(cache.profits);
            setAnnualSummaryLoading(false);
            return;
        }

        const fetchAnnualProfitYear = async () => {
            setAnnualSummaryLoading(true);
            try {
                const year = SelectedYear && String(SelectedYear).trim();
                if (!year || year.length !== 4) {
                    setAnnualProfitByMonth([]);
                    setAnnualSummaryLoading(false);
                    return;
                }
                // GET /sale.php/sale-profit-year?year=YYYY → profit_by_month (opción A) o profits (opción B, 12 números enero→diciembre)
                const response = await dotoniwoofApi.get(`/sale.php/sale-profit-year?year=${year}`);
                const data = response?.data;

                let profits = new Array(12).fill(0);
                if (data?.status === 'ok' && data?.code === 200) {
                    if (Array.isArray(data.profits) && data.profits.length >= 12) {
                        profits = data.profits.slice(0, 12).map((v) => Number(v) || 0);
                    } else if (Array.isArray(data.profit_by_month) && data.profit_by_month.length > 0) {
                        data.profit_by_month.forEach((item) => {
                            const idx = parseInt(String(item?.month || ''), 10) - 1; // "01"→0, "12"→11
                            if (idx >= 0 && idx < 12) profits[idx] = Number(item?.total_profit) || 0;
                        });
                    }
                }
                annualProfitCacheRef.current = { year: SelectedYear, profits };
                setAnnualProfitByMonth(profits);
            } catch (err) {
                console.error('Error loading annual profit (sale-profit-year):', err);
                setAnnualProfitByMonth([]);
            } finally {
                setAnnualSummaryLoading(false);
            }
        };
        fetchAnnualProfitYear();
    }, [SelectedYear]);

    // Nuevo useEffect para obtener ventas por método de pago del día
    useEffect(() => {
        const fetchPaymentMethodData = async () => {
            try {
                // Obtener fecha local de Colombia (GMT-5)
                const today = new Date();
                const year = today.getFullYear();
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const day = String(today.getDate()).padStart(2, '0');
                const todayStr = `${year}-${month}-${day}`;
                
                console.log('🔄 Fetching payment method data for date (Colombia GMT-5):', todayStr);
                
                // Endpoint: /sale.php/sale-paymentmethod-today?date=YYYY-MM-DD
                const response = await dotoniwoofApi.get(`/sale.php/sale-paymentmethod-today?date=${todayStr}`);
                
                console.log('✅ Payment method response:', response.data);
                
                // Response: { status: "ok", code: 200, message: "VENTAS DEL DÍA POR MÉTODO DE PAGO", date: "2025-10-20", total: 183500, methods: [{method: "Efectivo", total: 95000}] }
                if (response.data && response.data.status === 'ok' && response.data.methods) {
                    const methods = response.data.methods;
                    const labels = methods.map(item => item.method);
                    const data = methods.map(item => item.total);
                    
                    // Colores diferentes para cada método de pago
                    const colors = [
                        '#31a184', // Verde
                        '#EA9D0E', // Dorado
                        '#332E5A', // Morado
                        '#17a2b8', // Azul
                        '#ff3131', // Rojo
                        '#ffde59', // Amarillo
                        '#6f42c1', // Púrpura
                        '#fd7e14'  // Naranja
                    ];
                    
                    setPaymentMethodData({
                        labels: labels,
                        datasets: [{
                            data: data,
                            backgroundColor: colors.slice(0, methods.length).map(c => c + '30'),
                            borderColor: colors.slice(0, methods.length),
                            borderWidth: 3,
                            hoverOffset: 15
                        }],
                        total: response.data.total || 0,
                        methods: methods
                    });
                    
                    console.log('💳 Payment methods set:', methods);
                }
            } catch (err) {
                console.error('❌ Error loading payment method data:', err);
                console.error('Error details:', err.response?.data || err.message);
                // Datos de ejemplo en caso de error
                setPaymentMethodData({
                    labels: ['Sin datos'],
                    datasets: [{
                        data: [0],
                        backgroundColor: ['rgba(234, 157, 14, 0.2)'],
                        borderColor: ['#EA9D0E'],
                        borderWidth: 2
                    }],
                    total: 0,
                    methods: []
                });
            }
        };
        fetchPaymentMethodData();
    }, []); // Se ejecuta solo al montar el componente

    // Nuevo useEffect para obtener ventas de grooming por mes
    useEffect(() => {
        const fetchGroomingData = async () => {
            try {
                console.log('🔄 Fetching grooming sales data for year:', SelectedYear);
                
                // Endpoint: /sale-gromming-month?year=YYYY
                const response = await dotoniwoofApi.get(`/sale.php/sale-gromming-month?year=${SelectedYear}`);
                
                console.log('✅ Grooming response:', response.data);
                
                // Response: { status: "ok", code: 200, message: "...", year: 2025, data: { months: [...], sales: [...], commissions: [...] } }
                if (response.data && response.data.status === 'ok' && response.data.data) {
                    const { months, sales, commissions } = response.data.data;
                    
                    // Traducir meses al español
                    const monthTranslations = {
                        'January': 'Enero',
                        'February': 'Febrero',
                        'March': 'Marzo',
                        'April': 'Abril',
                        'May': 'Mayo',
                        'June': 'Junio',
                        'July': 'Julio',
                        'August': 'Agosto',
                        'September': 'Septiembre',
                        'October': 'Octubre',
                        'November': 'Noviembre',
                        'December': 'Diciembre'
                    };
                    
                    const translatedMonths = months.map(month => monthTranslations[month] || month);
                    
                    setGroomingData({
                        labels: translatedMonths,
                        datasets: [
                            {
                                label: 'Ventas ($)',
                                data: sales,
                                backgroundColor: chartColors.sales.background,
                                borderColor: chartColors.sales.border,
                                borderWidth: 2,
                                borderRadius: 6,
                                borderSkipped: false,
                            },
                        ],
                    });
                    
                    console.log('📊 Grooming data set:', { months: translatedMonths, sales, commissions });
                } else {
                    console.warn('⚠️ Grooming response not valid:', response.data);
                }
            } catch (err) {
                console.error('❌ Error loading grooming data:', err);
                console.error('Error details:', err.response?.data || err.message);
                // Datos vacíos en caso de error
                setGroomingData({
                    labels: [],
                    datasets: [],
                });
            }
        };
        fetchGroomingData();
    }, [SelectedYear]); // Se ejecuta cuando cambia el año seleccionado

    // Nuevo useEffect para obtener utilidad por categoría del mes
    useEffect(() => {
        const fetchProfitByCategory = async () => {
            try {
                console.log('🔄 Fetching profit by category for:', { month: SelectedMonth, year: SelectedYear });
                
                const response = await dotoniwoofApi.get(`/sale.php/sale-profit-by-category?month=${SelectedMonth}&year=${SelectedYear}`);
                
                console.log('✅ Profit by category response:', response.data);
                
                if (response.data?.code === 200 && Array.isArray(response.data.data)) {
                    const categories = response.data.data;
                    
                    if (categories.length === 0) {
                        setProfitByCategoryData({
                            labels: ['Sin datos'],
                            datasets: [{
                                label: 'Utilidad por Categoría',
                                data: [0],
                                backgroundColor: ['rgba(200, 200, 200, 0.2)'],
                                borderColor: ['#ccc'],
                                borderWidth: 2,
                                borderRadius: 8,
                                borderSkipped: false,
                            }]
                        });
                    } else {
                        const labels = categories.map(cat => cat.category_name || 'Sin nombre');
                        const data = categories.map(cat => parseFloat(cat.total_profit) || 0);
                        
                        // Generar colores dinámicos para cada categoría
                        const colors = categories.map((_, index) => {
                            const hue = (index * 137.5) % 360; // Golden angle para distribución uniforme
                            return `hsla(${hue}, 70%, 60%, 0.8)`;
                        });
                        
                        const borderColors = categories.map((_, index) => {
                            const hue = (index * 137.5) % 360;
                            return `hsla(${hue}, 70%, 50%, 1)`;
                        });
                        
                        setProfitByCategoryData({
                            labels: labels,
                            datasets: [{
                                label: 'Utilidad ($)',
                                data: data,
                                backgroundColor: colors,
                                borderColor: borderColors,
                                borderWidth: 2,
                                borderRadius: 8,
                                borderSkipped: false,
                            }]
                        });
                    }
                } else {
                    console.warn('⚠️ Profit by category response not valid:', response.data);
                    setProfitByCategoryData({
                        labels: ['Sin datos'],
                        datasets: [{
                            label: 'Utilidad por Categoría',
                            data: [0],
                            backgroundColor: ['rgba(200, 200, 200, 0.2)'],
                            borderColor: ['#ccc'],
                            borderWidth: 2,
                            borderRadius: 8,
                            borderSkipped: false,
                        }]
                    });
                }
            } catch (err) {
                console.error('❌ Error loading profit by category:', err);
                console.error('Error details:', err.response?.data || err.message);
                setProfitByCategoryData({
                    labels: ['Error'],
                    datasets: [{
                        label: 'Utilidad por Categoría',
                        data: [0],
                        backgroundColor: ['rgba(255, 0, 0, 0.2)'],
                        borderColor: ['#ff0000'],
                        borderWidth: 2,
                        borderRadius: 8,
                        borderSkipped: false,
                    }]
                });
            }
        };
        fetchProfitByCategory();
    }, [SelectedMonth, SelectedYear]); // Se ejecuta cuando cambia el mes o año seleccionado

    // Nuevo useEffect para obtener utilidad por categoría mensual (gráfico lineal)
    useEffect(() => {
        const fetchProfitByCategoryMonthly = async () => {
            try {
                console.log('🔄 Fetching monthly profit by category for year:', SelectedYear);
                
                const response = await dotoniwoofApi.get(`/sale.php/sale-profit-by-category-monthly?year=${SelectedYear}`);
                
                console.log('✅ Monthly profit by category response:', response.data);
                
                if (response.data?.code === 200 && Array.isArray(response.data.categories)) {
                    const categories = response.data.categories;
                    const monthLabels = response.data.month_labels || MONTH_LABELS;
                    
                    if (categories.length === 0) {
                        setProfitByCategoryMonthlyData({
                            labels: monthLabels,
                            datasets: [{
                                label: 'Sin datos',
                                data: Array(12).fill(0),
                                borderColor: 'rgba(200, 200, 200, 0.5)',
                                backgroundColor: 'rgba(200, 200, 200, 0.1)',
                                borderWidth: 2,
                                tension: 0.4,
                                fill: true,
                                pointRadius: 4,
                                pointHoverRadius: 6,
                            }]
                        });
                    } else {
                        // Generar datasets para cada categoría
                        const datasets = categories.map((category, index) => {
                            const hue = (index * 137.5) % 360; // Golden angle para distribución uniforme
                            const color = `hsla(${hue}, 70%, 55%, 1)`;
                            const bgColor = `hsla(${hue}, 70%, 55%, 0.1)`;
                            
                            return {
                                label: category.category_name || 'Sin nombre',
                                data: category.profits_by_month || Array(12).fill(0),
                                borderColor: color,
                                backgroundColor: bgColor,
                                borderWidth: 3,
                                tension: 0.4,
                                fill: true,
                                pointRadius: 5,
                                pointHoverRadius: 7,
                                pointBackgroundColor: color,
                                pointBorderColor: '#fff',
                                pointBorderWidth: 2,
                                pointHoverBackgroundColor: color,
                                pointHoverBorderColor: '#fff',
                                pointHoverBorderWidth: 3,
                            };
                        });
                        
                        setProfitByCategoryMonthlyData({
                            labels: monthLabels,
                            datasets: datasets
                        });
                    }
                } else {
                    console.warn('⚠️ Monthly profit by category response not valid:', response.data);
                    setProfitByCategoryMonthlyData({
                        labels: MONTH_LABELS,
                        datasets: [{
                            label: 'Sin datos',
                            data: Array(12).fill(0),
                            borderColor: 'rgba(200, 200, 200, 0.5)',
                            backgroundColor: 'rgba(200, 200, 200, 0.1)',
                            borderWidth: 2,
                            tension: 0.4,
                            fill: true,
                            pointRadius: 4,
                            pointHoverRadius: 6,
                        }]
                    });
                }
            } catch (err) {
                console.error('❌ Error loading monthly profit by category:', err);
                console.error('Error details:', err.response?.data || err.message);
                setProfitByCategoryMonthlyData({
                    labels: MONTH_LABELS,
                    datasets: [{
                        label: 'Error',
                        data: Array(12).fill(0),
                        borderColor: 'rgba(255, 0, 0, 0.5)',
                        backgroundColor: 'rgba(255, 0, 0, 0.1)',
                        borderWidth: 2,
                        tension: 0.4,
                        fill: true,
                        pointRadius: 4,
                        pointHoverRadius: 6,
                    }]
                });
            }
        };
        fetchProfitByCategoryMonthly();
    }, [SelectedYear]); // Se ejecuta cuando cambia el año seleccionado

    // Configuración moderna de opciones para gráficos
    const getChartOptions = (title, type = 'bar') => ({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    usePointStyle: true,
                    padding: 20,
                    font: {
                        size: 12,
                        weight: '500'
                    }
                }
            },
            title: {
                display: true,
                text: title,
                font: {
                    size: 16,
                    weight: 'bold'
                },
                color: brandColors.secondary,
                padding: {
                    top: 10,
                    bottom: 20
                }
            },
            tooltip: {
                backgroundColor: 'rgba(51, 46, 90, 0.9)',
                titleColor: '#fff',
                bodyColor: '#fff',
                borderColor: brandColors.primary,
                borderWidth: 1,
                cornerRadius: 8,
                displayColors: true,
                padding: 12
            }
        },
        scales: (type === 'bar' || type === 'line') ? {
            x: {
                grid: {
                    display: type === 'line',
                    color: 'rgba(51, 46, 90, 0.06)'
                },
                ticks: {
                    font: { size: 11 },
                    color: brandColors.secondary
                }
            },
            y: {
                beginAtZero: true,
                grid: {
                    color: 'rgba(51, 46, 90, 0.1)',
                    drawBorder: false
                },
                ticks: {
                    font: { size: 11 },
                    color: brandColors.secondary,
                    callback: function(value) {
                        return new Intl.NumberFormat('es-CO', {
                            style: 'currency',
                            currency: 'COP',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        }).format(value);
                    }
                }
            }
        } : {},
        interaction: {
            intersect: false,
            mode: 'index'
        }
    });

    const getHorizontalBarOptions = (title) => ({
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    usePointStyle: true,
                    padding: 20,
                    font: {
                        size: 12,
                        weight: '500'
                    }
                }
            },
            title: {
                display: true,
                text: title,
                font: {
                    size: 16,
                    weight: 'bold'
                },
                color: brandColors.secondary,
                padding: {
                    top: 10,
                    bottom: 20
                }
            },
            tooltip: {
                backgroundColor: 'rgba(51, 46, 90, 0.9)',
                titleColor: '#fff',
                bodyColor: '#fff',
                borderColor: brandColors.primary,
                borderWidth: 1,
                cornerRadius: 8,
                displayColors: true,
                padding: 12
            }
        },
        scales: {
            x: {
                grid: {
                    color: 'rgba(51, 46, 90, 0.1)',
                    drawBorder: false
                },
                ticks: {
                    font: {
                        size: 11
                    },
                    color: brandColors.secondary,
                    callback: function(value) {
                        return new Intl.NumberFormat('es-CO', {
                            style: 'currency',
                            currency: 'COP',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        }).format(value);
                    }
                }
            },
            y: {
                grid: {
                    display: false
                },
                ticks: {
                    font: {
                        size: 11
                    },
                    color: brandColors.secondary
                }
            }
        },
        interaction: {
            intersect: false,
            mode: 'index'
        }
    });

    const getPieOptions = (title) => ({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'right',
                labels: {
                    usePointStyle: true,
                    padding: 15,
                    font: {
                        size: 11,
                        weight: '500'
                    }
                }
            },
            title: {
                display: true,
                text: title,
                font: {
                    size: 16,
                    weight: 'bold'
                },
                color: brandColors.secondary,
                padding: {
                    top: 10,
                    bottom: 20
                }
            },
            tooltip: {
                backgroundColor: 'rgba(51, 46, 90, 0.9)',
                titleColor: '#fff',
                bodyColor: '#fff',
                borderColor: brandColors.primary,
                borderWidth: 1,
                cornerRadius: 8,
                displayColors: true,
                padding: 12,
                callbacks: {
                    label: function(context) {
                        const label = context.label || '';
                        const value = context.parsed;
                        const total = context.dataset.data.reduce((a, b) => a + b, 0);
                        const percentage = ((value / total) * 100).toFixed(1);
                        return `${label}: ${new Intl.NumberFormat('es-CO', {
                            style: 'currency',
                            currency: 'COP',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        }).format(value)} (${percentage}%)`;
                    }
                }
            }
        },
        interaction: {
            intersect: false,
            mode: 'index'
        }
    });

    const getDoughnutOptions = (title) => ({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    padding: 20,
                    font: {
                        size: 12,
                        weight: '500'
                    },
                    generateLabels: function(chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            return data.labels.map((label, i) => {
                                const value = data.datasets[0].data[i];
                                const total = data.datasets[0].data.reduce((a, b) => a + b, 0);
                                const percentage = ((value / total) * 100).toFixed(1);
                                return {
                                    text: `${label} (${percentage}%)`,
                                    fillStyle: data.datasets[0].borderColor[i],
                                    hidden: false,
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                }
            },
            title: {
                display: false
            },
            tooltip: {
                backgroundColor: 'rgba(51, 46, 90, 0.95)',
                titleColor: '#fff',
                bodyColor: '#fff',
                borderColor: brandColors.primary,
                borderWidth: 2,
                cornerRadius: 10,
                displayColors: true,
                padding: 15,
                callbacks: {
                    label: function(context) {
                        const label = context.label || '';
                        const value = context.parsed;
                        const total = context.dataset.data.reduce((a, b) => a + b, 0);
                        const percentage = ((value / total) * 100).toFixed(1);
                        return `${label}: ${new Intl.NumberFormat('es-CO', {
                            style: 'currency',
                            currency: 'COP',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        }).format(value)} (${percentage}%)`;
                    }
                }
            }
        },
        cutout: '65%',
        interaction: {
            intersect: false,
            mode: 'nearest'
        }
    });

    const profitExpenseNetChartData = useMemo(() => {
        const labels = MONTH_LABELS;
        const ventasRaw = salesData.datasets?.[0]?.data || [];
        const gastosRaw = salesData.datasets?.[1]?.data || [];
        const raw = annualProfitByMonth || [];
        const comprasRaw = purchaseReportByMonth || [];

        const toTwelveMonths = (arr) => {
            const n = (arr && arr.length) || 0;
            if (n === 11) {
                return labels.map((_, i) => (i === 0 ? 0 : Number(arr[i - 1]) || 0));
            }
            return labels.map((_, i) => Number(arr[i]) || 0);
        };

        const ventas = toTwelveMonths(ventasRaw);
        const gastos = toTwelveMonths(gastosRaw);
        const compras = toTwelveMonths(comprasRaw);
        const utilidadBruta = labels.map((_, i) => Number(raw[i]) || 0);
        const utilidadNeta = labels.map((_, i) => utilidadBruta[i] - gastos[i]);
        return {
            labels,
            datasets: [
                {
                    label: 'Utilidad bruta ($)',
                    data: utilidadBruta,
                    borderColor: '#31a184',
                    backgroundColor: 'rgba(49, 161, 132, 0.1)',
                    borderWidth: 2,
                    fill: true,
                    tension: 0.3,
                    pointBackgroundColor: '#31a184',
                    pointBorderColor: '#fff',
                    pointBorderWidth: 1
                },
                {
                    label: 'Utilidad neta ($)',
                    data: utilidadNeta,
                    borderColor: '#0d6efd',
                    backgroundColor: 'rgba(13, 110, 253, 0.1)',
                    borderWidth: 2,
                    fill: true,
                    tension: 0.3,
                    pointBackgroundColor: '#0d6efd',
                    pointBorderColor: '#fff',
                    pointBorderWidth: 1
                },
                {
                    label: 'Ventas mensuales ($)',
                    data: ventas,
                    borderColor: '#EA9D0E',
                    backgroundColor: 'rgba(234, 157, 14, 0.1)',
                    borderWidth: 2,
                    fill: true,
                    tension: 0.3,
                    pointBackgroundColor: '#EA9D0E',
                    pointBorderColor: '#fff',
                    pointBorderWidth: 1
                },
                {
                    label: 'Gastos mensuales ($)',
                    data: gastos,
                    borderColor: '#ff3131',
                    backgroundColor: 'rgba(255, 49, 49, 0.1)',
                    borderWidth: 2,
                    fill: true,
                    tension: 0.3,
                    pointBackgroundColor: '#ff3131',
                    pointBorderColor: '#fff',
                    pointBorderWidth: 1
                },
                {
                    label: 'Compras mensuales ($)',
                    data: compras,
                    borderColor: '#6f42c1',
                    backgroundColor: 'rgba(111, 66, 193, 0.1)',
                    borderWidth: 2,
                    fill: true,
                    tension: 0.3,
                    pointBackgroundColor: '#6f42c1',
                    pointBorderColor: '#fff',
                    pointBorderWidth: 1
                }
            ]
        };
    }, [salesData, annualProfitByMonth, purchaseReportByMonth]);

    const annualTotals = useMemo(() => {
        const ventas = salesData.datasets?.[0]?.data || [];
        const gastos = salesData.datasets?.[1]?.data || [];
        const ventasAnuales = ventas.reduce((s, v) => s + (Number(v) || 0), 0);
        const utilidadBrutaAnual = (annualProfitByMonth || []).reduce((s, v) => s + (Number(v) || 0), 0);
        const gastosAnuales = gastos.reduce((s, v) => s + (Number(v) || 0), 0);
        const utilidadNetaAnual = utilidadBrutaAnual - gastosAnuales;
        return { ventasAnuales, utilidadBrutaAnual, gastosAnuales, utilidadNetaAnual };
    }, [salesData, annualProfitByMonth]);

    const monthlyTotals = useMemo(() => {
        const ventasMensuales = (salesDataDay.datasets?.[0]?.data || []).reduce((s, v) => s + (Number(v) || 0), 0);
        const utilidadBrutaMensual = monthProfitData.totalProfit || 0;
        const gastosMensuales = monthExpensesTotal || 0;
        const utilidadNetaMensual = utilidadBrutaMensual - gastosMensuales;
        return { ventasMensuales, utilidadBrutaMensual, gastosMensuales, utilidadNetaMensual };
    }, [salesDataDay, monthProfitData.totalProfit, monthExpensesTotal]);

    // Meta mensual: basada en crecimiento anual del 20%. Meta año = ventas año anterior × (1 + 20%); meta mes = meta año / 12.
    const monthlyGoalData = useMemo(() => {
        const ventasAnualesAnterior = (prevYearSales || []).reduce((s, v) => s + (Number(v) || 0), 0);
        const metaAnual = ventasAnualesAnterior > 0 ? ventasAnualesAnterior * (1 + CRECIMIENTO_ANUAL) : 0;
        const meta = metaAnual > 0 ? Math.round(metaAnual / 12) : 0;
        const ventasActuales = monthlyTotals.ventasMensuales;

        const monthNum = parseInt(SelectedMonth, 10);
        const yearNum = parseInt(SelectedYear, 10);
        const daysInMonth = new Date(yearNum, monthNum, 0).getDate();
        const isCurrentMonth = monthNum === month + 1 && SelectedYear === year;
        const hoy = new Date().getDate();

        let ventasALaFecha = 0;
        let diasTranscurridos = daysInMonth;
        if (isCurrentMonth) {
            const salesByDay = salesDataDay.datasets?.[0]?.data || [];
            diasTranscurridos = Math.min(hoy, daysInMonth);
            for (let i = 0; i < diasTranscurridos && i < salesByDay.length; i++) {
                ventasALaFecha += Number(salesByDay[i]) || 0;
            }
        } else {
            ventasALaFecha = ventasActuales;
        }

        const ventasMesPasado = (() => {
            const ventas = salesData.datasets?.[0]?.data || [];
            if (monthNum >= 2) return Number(ventas[monthNum - 2]) || 0;
            return Number(prevYearSales[11]) || 0;
        })();
        const daysMesPasado = monthNum >= 2 ? new Date(yearNum, monthNum - 1, 0).getDate() : 31;
        const ventasMesPasadoALaFecha = ventasMesPasado > 0 && daysMesPasado > 0
            ? (ventasMesPasado / daysMesPasado) * diasTranscurridos
            : 0;
        const comparativoVsMesPasado = ventasMesPasadoALaFecha > 0
            ? ((ventasALaFecha - ventasMesPasadoALaFecha) / ventasMesPasadoALaFecha) * 100
            : null;

        const proyeccion = diasTranscurridos > 0 ? (ventasALaFecha / diasTranscurridos) * daysInMonth : 0;
        const progresoProyectado = meta > 0 ? (proyeccion / meta) * 100 : 0;
        const progreso = meta > 0 ? Math.min(100, (ventasActuales / meta) * 100) : 0;

        return {
            meta,
            metaAnual,
            ventasAnualesAnterior,
            progreso,
            ventasALaFecha,
            diasTranscurridos,
            ventasMesPasadoALaFecha,
            comparativoVsMesPasado,
            proyeccion,
            progresoProyectado,
            daysInMonth,
            isCurrentMonth
        };
    }, [prevYearSales, monthlyTotals.ventasMensuales, salesData, salesDataDay, SelectedMonth, SelectedYear, month]);

    const dailyGoalData = useMemo(() => {
        const metaMensual = monthlyGoalData.meta;
        const monthNum = parseInt(SelectedMonth, 10);
        const yearNum = parseInt(SelectedYear, 10);
        const daysInMonth = new Date(yearNum, monthNum, 0).getDate();
        const metaDiaria = metaMensual > 0 ? Math.round(metaMensual / daysInMonth) : 0;
        const isCurrentMonth = monthNum === month + 1 && SelectedYear === year;
        const ventasHoy = isCurrentMonth ? todaySalesValue : 0;
        const progresoDia = metaDiaria > 0 ? Math.min(100, (ventasHoy / metaDiaria) * 100) : 0;

        let ventasAyer = 0;
        let alcanzoMetaAyer = null;
        if (isCurrentMonth && metaDiaria > 0) {
            const hoy = new Date().getDate();
            if (hoy > 1) {
                const salesByDay = salesDataDay.datasets?.[0]?.data || [];
                const diaAyer = hoy - 1;
                const idxAyer = salesByDay.length >= diaAyer ? diaAyer - 1 : -1;
                const ventasAyerVal = idxAyer >= 0 ? Number(salesByDay[idxAyer]) || 0 : 0;
                ventasAyer = ventasAyerVal;
                alcanzoMetaAyer = ventasAyerVal >= metaDiaria;
            }
        }
        return { metaDiaria, ventasHoy, progresoDia, daysInMonth, isCurrentMonth, ventasAyer, alcanzoMetaAyer };
    }, [monthlyGoalData.meta, SelectedMonth, SelectedYear, month, year, todaySalesValue, salesDataDay]);

    const purchaseTermChartData = useMemo(() => {
        const items = purchaseTermReport.items || [];
        if (items.length === 0) {
            return {
                labels: ['Sin datos'],
                datasets: [{
                    data: [1],
                    backgroundColor: ['rgba(111, 66, 193, 0.2)'],
                    borderColor: ['#6f42c1'],
                    borderWidth: 2,
                    hoverOffset: 8
                }]
            };
        }
        const labels = items.map((i) => i.terms_name || `Término ${i.id_terms_type}`);
        const values = items.map((i) => Number(i.total_amount) || 0);
        const colors = chartColors.category;
        const bgColors = values.map((_, i) => colors[i % colors.length]);
        const borderColors = values.map((_, i) => colors[i % colors.length] + 'CC');
        return {
            labels,
            datasets: [{
                data: values,
                backgroundColor: bgColors,
                borderColor: borderColors,
                borderWidth: 2,
                hoverOffset: 8
            }]
        };
    }, [purchaseTermReport.items]);

    if (loading) {
        return (
            <div className="dashboard-loading">
                <Spinner animation="border" variant="primary" />
                <p>Cargando dashboard...</p>
            </div>
        );
    }

    if (error) {
        return (
            <Container className="mt-4">
                <Alert variant="danger">
                    <Alert.Heading>Error al cargar el dashboard</Alert.Heading>
                    <p>{error}</p>
                </Alert>
            </Container>
        );
    }

    return (
        <div className="modern-dashboard">
            <Container fluid className="dashboard-container">
                {/* Header del Dashboard */}
                <motion.div 
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="dashboard-header"
                >
                    <h1 className="dashboard-title">
                        <i className="fas fa-chart-line me-3"></i>
                        Dashboard {companyName}
                    </h1>
                    <p className="dashboard-subtitle">
                        Análisis completo de ventas y gastos
                    </p>
                </motion.div>

                {/* Controles de Filtros */}
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                    className="dashboard-controls"
                >
                    <Row className="g-3">
                        <Col md={6}>
                            <Card className="filter-card">
                                <Card.Body>
                                    <Form.Group>
                                        <Form.Label className="filter-label">
                                            <i className="fas fa-calendar-alt me-2"></i>
                                            Año
                                        </Form.Label>
                                        <Form.Select 
                                            value={SelectedYear} 
                                            onChange={(e) => setSelectedYear(e.target.value)}
                                            className="modern-select"
                                        >
                                            <option value={year}>Año actual ({year})</option>
                                            <option value="2025">2025</option>
                                            <option value="2024">2024</option>
                                            <option value="2023">2023</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card className="filter-card">
                                <Card.Body>
                                    <Form.Group>
                                        <Form.Label className="filter-label">
                                            <i className="fas fa-calendar me-2"></i>
                                            Mes
                                        </Form.Label>
                                        <Form.Select 
                                            value={SelectedMonth} 
                                            onChange={(e) => setSelectedMonth(e.target.value)}
                                            className="modern-select"
                                        >
                                            <option value={(month + 1).toString()}>Mes actual</option>
                                            <option value="01">Enero</option>
                                            <option value="02">Febrero</option>
                                            <option value="03">Marzo</option>
                                            <option value="04">Abril</option>
                                            <option value="05">Mayo</option>
                                            <option value="06">Junio</option>
                                            <option value="07">Julio</option>
                                            <option value="08">Agosto</option>
                                            <option value="09">Septiembre</option>
                                            <option value="10">Octubre</option>
                                            <option value="11">Noviembre</option>
                                            <option value="12">Diciembre</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </motion.div>

                {/* Banner motivador - Meta del mes */}
                <motion.div
                    initial={{ opacity: 0, y: 20, scale: 0.98 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    transition={{ duration: 0.5, delay: 0.12, ease: [0.34, 1.56, 0.64, 1] }}
                    className="mb-4"
                >
                    <Card className="goal-banner-card">
                        <Card.Body className="goal-banner-body">
                            <div className="goal-banner-content">
                                <div className="goal-banner-icon">
                                    <i className="fas fa-bullseye"></i>
                                </div>
                                <div className="goal-banner-text">
                                    <h6 className="goal-banner-title">
                                        Meta de ventas {MONTH_LABELS[parseInt(SelectedMonth, 10) - 1] || SelectedMonth} {SelectedYear}
                                    </h6>
                                    <p className="goal-banner-subtitle mb-1 d-flex align-items-center flex-wrap gap-2">
                                        {monthlyGoalData.meta > 0 ? (
                                            <>
                                                Hemos alcanzado el{' '}
                                                <strong>{monthlyGoalData.progreso.toFixed(0)}%</strong>
                                                {' '}de nuestra meta ({new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(monthlyTotals.ventasMensuales)} / {new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(monthlyGoalData.meta)})
                                                <span
                                                    className={`daily-face-badge ${
                                                        monthlyGoalData.progresoProyectado >= 90 ? 'daily-face-happy' :
                                                        monthlyGoalData.progresoProyectado >= 50 ? 'daily-face-medium' :
                                                        monthlyGoalData.progresoProyectado >= 40 ? 'daily-face-medium' :
                                                        'daily-face-sad'
                                                    }`}
                                                    title={
                                                        monthlyGoalData.progresoProyectado >= 90 ? 'Proyección: ¡Sí alcanzaremos la meta!' :
                                                        monthlyGoalData.progresoProyectado >= 50 ? 'Proyección: Vamos por buen camino' :
                                                        monthlyGoalData.progresoProyectado >= 40 ? 'Proyección: Necesitamos acelerar' :
                                                        'Proyección: Hay que esforzarnos más'
                                                    }
                                                >
                                                    <i className={`fas ${
                                                        monthlyGoalData.progresoProyectado >= 90 ? 'fa-smile' :
                                                        monthlyGoalData.progresoProyectado >= 40 ? 'fa-meh' :
                                                        'fa-frown'
                                                    }`}></i>
                                                </span>
                                            </>
                                        ) : (
                                            'Establezcamos una meta para motivarnos como equipo'
                                        )}
                                    </p>
                                    {monthlyGoalData.meta > 0 && monthlyGoalData.diasTranscurridos > 0 && (
                                        <div className="goal-banner-comparativo mt-2">
                                            <span className="goal-comparativo-item">
                                                <i className="fas fa-chart-line me-1"></i>
                                                A la fecha ({monthlyGoalData.diasTranscurridos} días): {new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(monthlyGoalData.ventasALaFecha)}
                                                {monthlyGoalData.comparativoVsMesPasado != null && (
                                                    <span className={monthlyGoalData.comparativoVsMesPasado >= 0 ? 'text-success ms-1' : 'text-danger ms-1'}>
                                                        ({monthlyGoalData.comparativoVsMesPasado >= 0 ? '+' : ''}{monthlyGoalData.comparativoVsMesPasado.toFixed(1)}% vs mes pasado)
                                                    </span>
                                                )}
                                            </span>
                                            <span className="goal-comparativo-item ms-3">
                                                <i className="fas fa-calculator me-1"></i>
                                                Proyección cierre: {new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(monthlyGoalData.proyeccion)}
                                                {monthlyGoalData.progresoProyectado >= 100 ? (
                                                    <span className="text-success ms-1">✓ Alcanzaremos la meta</span>
                                                ) : (
                                                    <span className="text-warning ms-1">({monthlyGoalData.progresoProyectado.toFixed(0)}% de la meta)</span>
                                                )}
                                            </span>
                                        </div>
                                    )}
                                </div>
                                <div className="goal-banner-message">
                                    {monthlyGoalData.progreso >= 100 ? (
                                        <span className="goal-msg-success"><i className="fas fa-trophy me-1"></i>¡Meta cumplida! Excelente trabajo en equipo</span>
                                    ) : monthlyGoalData.progreso >= 75 ? (
                                        <span className="goal-msg-warning"><i className="fas fa-fire me-1"></i>¡Casi lo logramos! Último empujón</span>
                                    ) : monthlyGoalData.progreso >= 50 ? (
                                        <span className="goal-msg-info"><i className="fas fa-chart-line me-1"></i>Vamos por buen camino, sigamos así</span>
                                    ) : monthlyGoalData.progreso > 0 ? (
                                        <span className="goal-msg-default"><i className="fas fa-rocket me-1"></i>¡Podemos! Cada venta cuenta</span>
                                    ) : (
                                        <span className="goal-msg-default"><i className="fas fa-star me-1"></i>Comencemos el mes con energía</span>
                                    )}
                                </div>
                            </div>
                            {monthlyGoalData.meta > 0 && (
                                <div className="goal-banner-progress">
                                    <div className="goal-progress-track">
                                        <div
                                            className={`goal-progress-fill ${monthlyGoalData.progreso >= 100 ? 'goal-progress-complete' : ''}`}
                                            role="progressbar"
                                            style={{ width: `${monthlyGoalData.progreso}%` }}
                                            aria-valuenow={monthlyGoalData.progreso}
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                        />
                                    </div>
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </motion.div>

                {/* Meta diaria - derivada de la meta mensual */}
                {monthlyGoalData.meta > 0 && (
                    <motion.div
                        initial={{ opacity: 0, y: 20, scale: 0.98 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        transition={{ duration: 0.5, delay: 0.14, ease: [0.34, 1.56, 0.64, 1] }}
                        className="mb-4"
                    >
                        <Card className="daily-goal-card">
                            <Card.Body className="daily-goal-body">
                                <div className="daily-goal-content">
                                    <div className="daily-goal-icon">
                                        <i className="fas fa-bullseye"></i>
                                    </div>
                                    <div className="daily-goal-text">
                                        <h6 className="daily-goal-title">
                                            ¡Hoy nuestra meta es {new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(dailyGoalData.metaDiaria)}!
                                        </h6>
                                        <p className="daily-goal-subtitle mb-1">
                                            Cada día cuenta. Promedio necesario: {new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(dailyGoalData.metaDiaria)} ({dailyGoalData.daysInMonth} días)
                                        </p>
                                        {dailyGoalData.alcanzoMetaAyer !== null && (
                                            <div className={`daily-yesterday-badge ${dailyGoalData.alcanzoMetaAyer ? 'daily-yesterday-success' : 'daily-yesterday-miss'}`}>
                                                <i className={`fas ${dailyGoalData.alcanzoMetaAyer ? 'fa-check-circle' : 'fa-times-circle'} me-2`}></i>
                                                <span>
                                                    Ayer {dailyGoalData.alcanzoMetaAyer ? 'alcanzamos' : 'no alcanzamos'} la meta
                                                    {' '}({new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(dailyGoalData.ventasAyer)} / {new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(dailyGoalData.metaDiaria)})
                                                </span>
                                            </div>
                                        )}
                                        {dailyGoalData.isCurrentMonth && (
                                            <p className="daily-goal-today mt-2 mb-0 d-flex align-items-center flex-wrap gap-2">
                                                Hoy vamos en{' '}
                                                <strong>{new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(dailyGoalData.ventasHoy)}</strong>
                                                {' '}—{' '}
                                                <span className={dailyGoalData.progresoDia >= 100 ? 'daily-progress-success' : ''}>
                                                    {dailyGoalData.progresoDia.toFixed(0)}% de la meta
                                                </span>
                                                {dailyGoalData.metaDiaria > 0 && (
                                                    <span
                                                        className={`daily-face-badge ${
                                                            dailyGoalData.progresoDia >= 90 ? 'daily-face-happy' :
                                                            dailyGoalData.progresoDia >= 50 ? 'daily-face-medium' :
                                                            dailyGoalData.progresoDia >= 40 ? 'daily-face-medium' :
                                                            'daily-face-sad'
                                                        }`}
                                                        title={
                                                            dailyGoalData.progresoDia >= 90 ? '¡Excelente! Vamos muy bien' :
                                                            dailyGoalData.progresoDia >= 50 ? 'Vamos por buen camino' :
                                                            dailyGoalData.progresoDia >= 40 ? 'Vamos mejorando' :
                                                            '¡A darle! Todavía podemos lograrlo'
                                                        }
                                                    >
                                                        <i className={`fas ${
                                                            dailyGoalData.progresoDia >= 90 ? 'fa-smile' :
                                                            dailyGoalData.progresoDia >= 40 ? 'fa-meh' :
                                                            'fa-frown'
                                                        }`}></i>
                                                    </span>
                                                )}
                                            </p>
                                        )}
                                    </div>
                                    {dailyGoalData.isCurrentMonth && dailyGoalData.metaDiaria > 0 && (
                                        <div className="daily-goal-progress-wrap">
                                            <div className="goal-progress-track daily-goal-track">
                                                <div
                                                    className={`goal-progress-fill ${dailyGoalData.progresoDia >= 100 ? 'goal-progress-complete' : ''}`}
                                                    role="progressbar"
                                                    style={{ width: `${dailyGoalData.progresoDia}%` }}
                                                    aria-valuenow={dailyGoalData.progresoDia}
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </Card.Body>
                        </Card>
                    </motion.div>
                )}

                {/* Resumen anual y mensual: Ventas, Gastos, Utilidad neta */}
                <Row className="g-4 mt-3">
                    <Col xl={12}>
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.15 }}
                        >
                            <Card className="annual-summary-card">
                                <Card.Header className="annual-summary-card-header">
                                    <h5 className="annual-summary-card-title">
                                        <i className="fas fa-calendar-check me-2"></i>
                                        Resumen anual
                                    </h5>
                                    <span className="annual-summary-card-year">Año {SelectedYear}</span>
                                </Card.Header>
                                <Card.Body>
                                    {annualSummaryLoading ? (
                                        <div className="annual-summary-loading">
                                            <Spinner animation="border" variant="primary" className="annual-summary-spinner" />
                                            <p className="annual-summary-loading-text mb-0">Cargando valores anuales...</p>
                                        </div>
                                    ) : (
                                    <Row className="g-3">
                                        <Col md={6} lg={3}>
                                            <div className="annual-summary-stat annual-summary-sales">
                                                <div className="annual-summary-stat-icon">
                                                    <i className="fas fa-cash-register"></i>
                                                </div>
                                                <div className="annual-summary-stat-content">
                                                    <p className="annual-summary-stat-label">Ventas anuales</p>
                                                    <h4 className="annual-summary-stat-value">
                                                        {new Intl.NumberFormat('es-CO', {
                                                            style: 'currency',
                                                            currency: 'COP',
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        }).format(annualTotals.ventasAnuales)}
                                                    </h4>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6} lg={3}>
                                            <div className="annual-summary-stat annual-summary-gross">
                                                <div className="annual-summary-stat-icon">
                                                    <i className="fas fa-chart-line"></i>
                                                </div>
                                                <div className="annual-summary-stat-content">
                                                    <p className="annual-summary-stat-label">Utilidad bruta anual</p>
                                                    <h4 className="annual-summary-stat-value">
                                                        {new Intl.NumberFormat('es-CO', {
                                                            style: 'currency',
                                                            currency: 'COP',
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        }).format(annualTotals.utilidadBrutaAnual)}
                                                    </h4>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6} lg={3}>
                                            <div className="annual-summary-stat annual-summary-expenses">
                                                <div className="annual-summary-stat-icon">
                                                    <i className="fas fa-wallet"></i>
                                                </div>
                                                <div className="annual-summary-stat-content">
                                                    <p className="annual-summary-stat-label">Gastos anuales</p>
                                                    <h4 className="annual-summary-stat-value">
                                                        {new Intl.NumberFormat('es-CO', {
                                                            style: 'currency',
                                                            currency: 'COP',
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        }).format(annualTotals.gastosAnuales)}
                                                    </h4>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6} lg={3}>
                                            <div className={`annual-summary-stat annual-summary-net ${annualTotals.utilidadNetaAnual >= 0 ? 'annual-summary-net-positive' : 'annual-summary-net-negative'}`}>
                                                <div className="annual-summary-stat-icon">
                                                    <i className="fas fa-piggy-bank"></i>
                                                </div>
                                                <div className="annual-summary-stat-content">
                                                    <p className="annual-summary-stat-label">Utilidad neta anual</p>
                                                    <h4 className="annual-summary-stat-value">
                                                        {new Intl.NumberFormat('es-CO', {
                                                            style: 'currency',
                                                            currency: 'COP',
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        }).format(annualTotals.utilidadNetaAnual)}
                                                    </h4>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    )}
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>
                    <Col xl={12}>
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                        >
                            <Card className="annual-summary-card">
                                <Card.Header className="annual-summary-card-header">
                                    <h5 className="annual-summary-card-title">
                                        <i className="fas fa-calendar-alt me-2"></i>
                                        Resumen mensual
                                    </h5>
                                    <span className="annual-summary-card-year">
                                        {MONTH_LABELS[parseInt(SelectedMonth, 10) - 1] || SelectedMonth} {SelectedYear}
                                    </span>
                                </Card.Header>
                                <Card.Body>
                                    <Row className="g-3">
                                        <Col md={6} lg={3}>
                                            <div className="annual-summary-stat annual-summary-sales">
                                                <div className="annual-summary-stat-icon">
                                                    <i className="fas fa-cash-register"></i>
                                                </div>
                                                <div className="annual-summary-stat-content">
                                                    <p className="annual-summary-stat-label">Ventas del mes</p>
                                                    <h4 className="annual-summary-stat-value">
                                                        {new Intl.NumberFormat('es-CO', {
                                                            style: 'currency',
                                                            currency: 'COP',
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        }).format(monthlyTotals.ventasMensuales)}
                                                    </h4>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6} lg={3}>
                                            <div className="annual-summary-stat annual-summary-gross">
                                                <div className="annual-summary-stat-icon">
                                                    <i className="fas fa-chart-line"></i>
                                                </div>
                                                <div className="annual-summary-stat-content">
                                                    <p className="annual-summary-stat-label">Utilidad bruta del mes</p>
                                                    <h4 className="annual-summary-stat-value">
                                                        {new Intl.NumberFormat('es-CO', {
                                                            style: 'currency',
                                                            currency: 'COP',
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        }).format(monthlyTotals.utilidadBrutaMensual)}
                                                    </h4>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6} lg={3}>
                                            <div className="annual-summary-stat annual-summary-expenses">
                                                <div className="annual-summary-stat-icon">
                                                    <i className="fas fa-wallet"></i>
                                                </div>
                                                <div className="annual-summary-stat-content">
                                                    <p className="annual-summary-stat-label">Gastos del mes</p>
                                                    <h4 className="annual-summary-stat-value">
                                                        {new Intl.NumberFormat('es-CO', {
                                                            style: 'currency',
                                                            currency: 'COP',
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        }).format(monthlyTotals.gastosMensuales)}
                                                    </h4>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6} lg={3}>
                                            <div className={`annual-summary-stat annual-summary-net ${monthlyTotals.utilidadNetaMensual >= 0 ? 'annual-summary-net-positive' : 'annual-summary-net-negative'}`}>
                                                <div className="annual-summary-stat-icon">
                                                    <i className="fas fa-piggy-bank"></i>
                                                </div>
                                                <div className="annual-summary-stat-content">
                                                    <p className="annual-summary-stat-label">Utilidad neta del mes</p>
                                                    <h4 className="annual-summary-stat-value">
                                                        {new Intl.NumberFormat('es-CO', {
                                                            style: 'currency',
                                                            currency: 'COP',
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        }).format(monthlyTotals.utilidadNetaMensual)}
                                                    </h4>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>
                </Row>

                     {/* Ventas por Método de Pago del Día */}
                     <Row className="g-4 mt-4">
                    <Col xl={12}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.6, delay: 1 }}
                        >
                            <Card className="payment-method-card">
                                <Card.Header className="payment-header">
                                    <div className="payment-header-content">
                                        <div>
                                            <h5 className="chart-title mb-1">
                                                <i className="fas fa-credit-card me-2"></i>
                                                Ventas por Método de Pago
                                            </h5>
                                            <p className="payment-subtitle">Distribución de pagos del día</p>
                                        </div>
                                        <div className="payment-total-badge">
                                            <span className="payment-total-label">Total del Día</span>
                                            <span className="payment-total-value">
                                                {new Intl.NumberFormat('es-CO', {
                                                    style: 'currency',
                                                    currency: 'COP',
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0
                                                }).format(paymentMethodData.total)}
                                            </span>
                                        </div>
                                    </div>
                                </Card.Header>
                                <Card.Body className="payment-body">
                                    <Row>
                                        <Col lg={6} className="d-flex align-items-center justify-content-center">
                                            <div className="doughnut-container">
                                                <Doughnut 
                                                    data={paymentMethodData} 
                                                    options={getDoughnutOptions('Métodos de Pago')}
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            <div className="payment-methods-list">
                                                <h6 className="payment-list-title">Detalle por Método</h6>
                                                {paymentMethodData.methods && paymentMethodData.methods.length > 0 ? (
                                                    paymentMethodData.methods.map((method, index) => {
                                                        const percentage = ((method.total / paymentMethodData.total) * 100).toFixed(1);
                                                        const colors = [
                                                            '#31a184', '#EA9D0E', '#332E5A', '#17a2b8', 
                                                            '#ff3131', '#ffde59', '#6f42c1', '#fd7e14'
                                                        ];
                                                        return (
                                                            <motion.div 
                                                                key={index}
                                                                className="payment-method-item"
                                                                initial={{ opacity: 0, x: -20 }}
                                                                animate={{ opacity: 1, x: 0 }}
                                                                transition={{ duration: 0.4, delay: 1.2 + (index * 0.1) }}
                                                            >
                                                                <div className="payment-method-header">
                                                                    <div className="payment-method-name">
                                                                        <span 
                                                                            className="payment-method-dot"
                                                                            style={{ backgroundColor: colors[index % colors.length] }}
                                                                        ></span>
                                                                        {method.method}
                                                                    </div>
                                                                    <div className="payment-method-stats">
                                                                        <span className="payment-method-amount">
                                                                            {new Intl.NumberFormat('es-CO', {
                                                                                style: 'currency',
                                                                                currency: 'COP',
                                                                                minimumFractionDigits: 0,
                                                                                maximumFractionDigits: 0
                                                                            }).format(method.total)}
                                                                        </span>
                                                                        <span className="payment-method-percentage">{percentage}%</span>
                                                                    </div>
                                                                </div>
                                                                <div className="payment-method-progress">
                                                                    <motion.div 
                                                                        className="payment-method-progress-bar"
                                                                        style={{ 
                                                                            backgroundColor: colors[index % colors.length],
                                                                            width: `${percentage}%`
                                                                        }}
                                                                        initial={{ width: 0 }}
                                                                        animate={{ width: `${percentage}%` }}
                                                                        transition={{ duration: 0.8, delay: 1.4 + (index * 0.1) }}
                                                                    />
                                                                </div>
                                                            </motion.div>
                                                        );
                                                    })
                                                ) : (
                                                    <p className="text-muted text-center">No hay datos disponibles</p>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>
                </Row>

                {/* KPIs del Día - Tarjetas Animadas */}
                <Row className="g-4 mt-2">
                    {/* Ventas del Día */}
                    <Col xl={3} lg={6} md={6}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                            whileHover={{ scale: 1.05 }}
                        >
                            <Card className="kpi-card kpi-card-primary">
                                <Card.Body>
                                    <div className="kpi-content">
                                        <div className="kpi-icon-container">
                                            <i className="fas fa-dollar-sign kpi-icon"></i>
                                        </div>
                                        <div className="kpi-info">
                                            <h6 className="kpi-label">Ventas del Día</h6>
                                            <motion.div
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.8, delay: 0.4 }}
                                            >
                                                <h2 className="kpi-value">
                                                    {new Intl.NumberFormat('es-CO', {
                                                        style: 'currency',
                                                        currency: 'COP',
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    }).format(todaySalesValue)}
                                                </h2>
                                            </motion.div>
                                            <p className="kpi-subtitle">
                                                <i className="fas fa-calendar-day me-1"></i>
                                                {new Date().toLocaleDateString('es-CO', { 
                                                    weekday: 'long', 
                                                    year: 'numeric', 
                                                    month: 'long', 
                                                    day: 'numeric' 
                                                })}
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>

                    {/* Ticket Promedio */}
                    <Col xl={3} lg={6} md={6}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.3 }}
                            whileHover={{ scale: 1.05 }}
                        >
                            <Card className="kpi-card kpi-card-success">
                                <Card.Body>
                                    <div className="kpi-content">
                                        <div className="kpi-icon-container">
                                            <i className="fas fa-receipt kpi-icon"></i>
                                        </div>
                                        <div className="kpi-info">
                                            <h6 className="kpi-label">Ticket Promedio</h6>
                                            <motion.div
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.8, delay: 0.5 }}
                                            >
                                                <h2 className="kpi-value">
                                                    {new Intl.NumberFormat('es-CO', {
                                                        style: 'currency',
                                                        currency: 'COP',
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    }).format(kpiData.ticketPromedio)}
                                                </h2>
                                            </motion.div>
                                            <p className="kpi-subtitle">
                                                <i className="fas fa-chart-line me-1"></i>
                                                Por transacción
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>

                    {/* Total Transacciones */}
                    <Col xl={3} lg={6} md={6}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.4 }}
                            whileHover={{ scale: 1.05 }}
                        >
                            <Card className="kpi-card kpi-card-info">
                                <Card.Body>
                                    <div className="kpi-content">
                                        <div className="kpi-icon-container">
                                            <i className="fas fa-shopping-cart kpi-icon"></i>
                                        </div>
                                        <div className="kpi-info">
                                            <h6 className="kpi-label">Transacciones</h6>
                                            <motion.div
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.8, delay: 0.6 }}
                                            >
                                                <h2 className="kpi-value">{kpiData.totalTransacciones}</h2>
                                            </motion.div>
                                            <p className="kpi-subtitle">
                                                <i className="fas fa-business-time me-1"></i>
                                                Ventas del día
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>

                    {/* Comparación vs Día Anterior */}
                    <Col xl={3} lg={6} md={6}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.5 }}
                            whileHover={{ scale: 1.05 }}
                        >
                            <Card className={`kpi-card ${kpiData.ventasVsDiaAnterior >= 0 ? 'kpi-card-success' : 'kpi-card-danger'}`}>
                                <Card.Body>
                                    <div className="kpi-content">
                                        <div className="kpi-icon-container">
                                            <i className={`fas fa-arrow-${kpiData.ventasVsDiaAnterior >= 0 ? 'up' : 'down'} kpi-icon`}></i>
                                        </div>
                                        <div className="kpi-info">
                                            <h6 className="kpi-label">vs Día Anterior</h6>
                                            <motion.div
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.8, delay: 0.7 }}
                                            >
                                                <h2 className="kpi-value">
                                                    {kpiData.ventasVsDiaAnterior >= 0 ? '+' : ''}{kpiData.ventasVsDiaAnterior.toFixed(1)}%
                                                </h2>
                                            </motion.div>
                                            <p className="kpi-subtitle">
                                                <i className="fas fa-chart-area me-1"></i>
                                                Comparación
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>

                </Row>

                {/* Sección: Resumen de Compras */}
                <Row className="g-4 mt-3">
                    <Col xl={12}>
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.55 }}
                        >
                            <Card className="dashboard-section-card purchases-section-card">
                                <Card.Header className="dashboard-section-header">
                                    <h5 className="dashboard-section-title">
                                        <i className="fas fa-shopping-bag me-2"></i>
                                        Resumen de Compras
                                    </h5>
                                    <span className="dashboard-section-subtitle">
                                        {new Date().toLocaleDateString('es-CO', { month: 'long', year: 'numeric' })}
                                    </span>
                                </Card.Header>
                                <Card.Body>
                                    <Row className="g-4">
                    {/* Compras del mes */}
                    <Col xl={3} lg={6} md={6}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.55 }}
                            whileHover={{ scale: 1.05 }}
                        >
                            <Card className="kpi-card kpi-card-purple">
                                <Card.Body>
                                    <div className="kpi-content">
                                        <div className="kpi-icon-container">
                                            <i className="fas fa-shopping-bag kpi-icon"></i>
                                        </div>
                                        <div className="kpi-info">
                                            <h6 className="kpi-label">Compras del mes</h6>
                                            <motion.div
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.8, delay: 0.75 }}
                                            >
                                                <h2 className="kpi-value">
                                                    {new Intl.NumberFormat('es-CO', {
                                                        style: 'currency',
                                                        currency: 'COP',
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    }).format(monthPurchasesTotal)}
                                                </h2>
                                            </motion.div>
                                            <p className="kpi-subtitle">
                                                <i className="fas fa-calendar-alt me-1"></i>
                                                {new Date().toLocaleDateString('es-CO', { month: 'long', year: 'numeric' })}
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>

                    {/* Pendiente por pagar */}
                    <Col xl={3} lg={6} md={6}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.58 }}
                            whileHover={{ scale: 1.05 }}
                        >
                            <Card className="kpi-card kpi-card-warning">
                                <Card.Body>
                                    <div className="kpi-content">
                                        <div className="kpi-icon-container">
                                            <i className="fas fa-clock kpi-icon"></i>
                                        </div>
                                        <div className="kpi-info">
                                            <h6 className="kpi-label">Pendiente por pagar</h6>
                                            <motion.div
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.8, delay: 0.78 }}
                                            >
                                                <h2 className="kpi-value">
                                                    {new Intl.NumberFormat('es-CO', {
                                                        style: 'currency',
                                                        currency: 'COP',
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    }).format(monthPurchasesPending)}
                                                </h2>
                                            </motion.div>
                                            <p className="kpi-subtitle">
                                                <i className="fas fa-file-invoice-dollar me-1"></i>
                                                Compras sin pagar
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>

                    {/* Vencido */}
                    <Col xl={3} lg={6} md={6}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.61 }}
                            whileHover={{ scale: 1.05 }}
                        >
                            <Card className="kpi-card kpi-card-danger">
                                <Card.Body>
                                    <div className="kpi-content">
                                        <div className="kpi-icon-container">
                                            <i className="fas fa-exclamation-triangle kpi-icon"></i>
                                        </div>
                                        <div className="kpi-info">
                                            <h6 className="kpi-label">Vencido</h6>
                                            <motion.div
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.8, delay: 0.81 }}
                                            >
                                                <h2 className="kpi-value">
                                                    {new Intl.NumberFormat('es-CO', {
                                                        style: 'currency',
                                                        currency: 'COP',
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    }).format(monthPurchasesOverdue)}
                                                </h2>
                                            </motion.div>
                                            <p className="kpi-subtitle">
                                                <i className="fas fa-calendar-times me-1"></i>
                                                Compras vencidas
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>

                    {/* Variación compras vs mes anterior */}
                    <Col xl={3} lg={6} md={6}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.64 }}
                            whileHover={{ scale: 1.05 }}
                        >
                            <Card className={`kpi-card ${purchasesVariationVsPrevious == null ? 'kpi-card-info' : (purchasesVariationVsPrevious >= 0 ? 'kpi-card-success' : 'kpi-card-danger')}`}>
                                <Card.Body>
                                    <div className="kpi-content">
                                        <div className="kpi-icon-container">
                                            <i className={`fas fa-arrow-${purchasesVariationVsPrevious == null || purchasesVariationVsPrevious >= 0 ? 'up' : 'down'} kpi-icon`}></i>
                                        </div>
                                        <div className="kpi-info">
                                            <h6 className="kpi-label">Variación vs mes anterior</h6>
                                            <motion.div
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.8, delay: 0.84 }}
                                            >
                                                <h2 className="kpi-value">
                                                    {purchasesVariationVsPrevious != null
                                                        ? `${purchasesVariationVsPrevious >= 0 ? '+' : ''}${purchasesVariationVsPrevious.toFixed(1)}%`
                                                        : '-'}
                                                </h2>
                                            </motion.div>
                                            <p className="kpi-subtitle">
                                                <i className="fas fa-chart-line me-1"></i>
                                                Compras
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>
                                    </Row>

                                    {/* Gráfico y KPIs por término de crédito */}
                                    {purchaseTermReport.items.length > 0 && (
                                        <Row className="g-4 mt-3 pt-3 border-top">
                                            <Col xl={6} lg={12}>
                                                <div className="purchase-term-chart-container">
                                                    <h6 className="purchase-term-chart-title">
                                                        <i className="fas fa-chart-pie me-2"></i>
                                                        Compras por término de crédito
                                                    </h6>
                                                    <div style={{ minHeight: '260px' }}>
                                                        <Doughnut
                                                            data={purchaseTermChartData}
                                                            options={getDoughnutOptions('Compras por término')}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col xl={6} lg={12}>
                                                <div className="purchase-term-summary">
                                                    <h6 className="purchase-term-chart-title">
                                                        <i className="fas fa-list-alt me-2"></i>
                                                        Resumen por término
                                                    </h6>
                                                    <div className="purchase-term-boxes">
                                                        {purchaseTermReport.items.map((item, idx) => {
                                                            const colors = chartColors.category;
                                                            const color = colors[idx % colors.length];
                                                            return (
                                                                <div key={item.id_terms_type ?? idx} className="purchase-term-box" style={{ borderTopColor: color }}>
                                                                    <span className="purchase-term-box-name">{item.terms_name || 'Sin término'}</span>
                                                                    <span className="purchase-term-box-meta">{item.purchase_count} compra(s)</span>
                                                                    <span className="purchase-term-box-amount">
                                                                        {new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(item.total_amount || 0)}
                                                                    </span>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                    <div className="purchase-term-text-totals">
                                                        <span className="purchase-term-total-line">
                                                            <i className="fas fa-coins me-2"></i>
                                                            Total general: <strong>{new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(purchaseTermReport.summary?.grand_total || 0)}</strong>
                                                        </span>
                                                        <span className="purchase-term-total-line">
                                                            <i className="fas fa-receipt me-2"></i>
                                                            Total compras: <strong>{purchaseTermReport.summary?.total_purchases ?? 0}</strong>
                                                        </span>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}

                                    {/* Compras por vencer (próximos 7 días) */}
                                    <Row className="g-4 mt-3 pt-3 border-top">
                                        <Col xl={12}>
                                            <div className="purchase-due-soon-section">
                                                <div className="purchase-due-soon-header">
                                                    <h6 className="purchase-due-soon-title">
                                                        <i className="fas fa-calendar-check me-2"></i>
                                                        Compras por vencer (próximos 7 días)
                                                    </h6>
                                                    {purchaseDueSoon.purchases.length > 0 && (
                                                        <span className="purchase-due-soon-badge">
                                                            {purchaseDueSoon.summary?.count ?? 0} pendiente(s)
                                                        </span>
                                                    )}
                                                </div>
                                                {purchaseDueSoon.purchases.length === 0 ? (
                                                    <div className="purchase-due-soon-empty">
                                                        <i className="fas fa-check-circle purchase-due-soon-empty-icon"></i>
                                                        <p className="purchase-due-soon-empty-text mb-0">
                                                            No hay compras pendientes que venzan en los próximos 7 días.
                                                        </p>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div className="purchase-due-soon-table">
                                                            <div className="purchase-due-soon-table-header">
                                                                <span>Referencia</span>
                                                                <span>Proveedor</span>
                                                                <span>Término</span>
                                                                <span>Vence</span>
                                                                <span>Días</span>
                                                                <span>Total</span>
                                                            </div>
                                                            {purchaseDueSoon.purchases.map((p) => {
                                                                const dateStr = (p.due_date || '').toString().split(/[\sT]/)[0];
                                                                const formattedDate = dateStr ? new Date(dateStr + 'T12:00:00').toLocaleDateString('es-CO', { day: '2-digit', month: 'short', year: 'numeric' }) : '-';
                                                                return (
                                                                <div key={p.id_purchase} className="purchase-due-soon-table-row">
                                                                    <span className="purchase-due-soon-ref">{p.reference_doc || `#${p.id_purchase}`}</span>
                                                                    <span>{p.supplier_name || '-'}</span>
                                                                    <span>{p.terms_name || '-'}</span>
                                                                    <span>{formattedDate}</span>
                                                                    <span className={`purchase-due-soon-days ${(p.days_until_due ?? 0) <= 2 ? 'purchase-due-soon-urgent' : ''}`}>
                                                                        {p.days_until_due != null ? `${p.days_until_due} día(s)` : '-'}
                                                                    </span>
                                                                    <span className="purchase-due-soon-amount">
                                                                        {new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(p.grand_total ?? 0)}
                                                                    </span>
                                                                </div>
                                                            );})}
                                                        </div>
                                                        <div className="purchase-due-soon-summary">
                                                            <span className="purchase-due-soon-summary-label">Total</span>
                                                            <span className="purchase-due-soon-summary-sep">·</span>
                                                            <span className="purchase-due-soon-summary-amount">{new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(purchaseDueSoon.summary?.total_amount ?? 0)}</span>
                                                            <span className="purchase-due-soon-summary-sep">·</span>
                                                            <span className="purchase-due-soon-summary-count">{purchaseDueSoon.summary?.count ?? 0} compra(s)</span>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>
                </Row>

    {/* Tarjeta de Utilidad Promedio */}
    <Row className="g-4 mt-4">
                    <Col xl={12}>
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.8 }}
                        >
                            <Card className="profit-card">
                                <Card.Body className="profit-body">
                                    <Row className="align-items-center">
                                        <Col md={4} className="text-center profit-icon-section">
                                            <motion.div
                                                className="profit-icon-container"
                                                animate={{ 
                                                    scale: [1, 1.05, 1],
                                                    rotate: [0, 5, -5, 0]
                                                }}
                                                transition={{ 
                                                    duration: 3,
                                                    repeat: Infinity,
                                                    repeatDelay: 2
                                                }}
                                            >
                                                <i className="fas fa-hand-holding-usd profit-icon"></i>
                                            </motion.div>
                                            <h3 className="profit-label">Utilidad del Día</h3>
                                        </Col>
                                        <Col md={8}>
                                            <Row className="g-3">
                                                <Col sm={4}>
                                                    <div className="profit-stat-card">
                                                        <div className="profit-stat-icon">
                                                            <i className="fas fa-chart-line"></i>
                                                        </div>
                                                        <div className="profit-stat-content">
                                                            <p className="profit-stat-label">Utilidad Total</p>
                                                            <motion.h4 
                                                                className="profit-stat-value"
                                                                initial={{ opacity: 0, scale: 0.5 }}
                                                                animate={{ opacity: 1, scale: 1 }}
                                                                transition={{ duration: 0.5, delay: 1 }}
                                                            >
                                                                {new Intl.NumberFormat('es-CO', {
                                                                    style: 'currency',
                                                                    currency: 'COP',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                }).format(profitData.totalProfit)}
                                                            </motion.h4>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col sm={4}>
                                                    <div className="profit-stat-card profit-stat-card-highlight">
                                                        <div className="profit-stat-icon">
                                                            <i className="fas fa-percentage"></i>
                                                        </div>
                                                        <div className="profit-stat-content">
                                                            <p className="profit-stat-label">Utilidad Promedio</p>
                                                            <motion.h4 
                                                                className="profit-stat-value profit-stat-value-highlight"
                                                                initial={{ opacity: 0, scale: 0.5 }}
                                                                animate={{ opacity: 1, scale: 1 }}
                                                                transition={{ duration: 0.5, delay: 1.2 }}
                                                            >
                                                                {new Intl.NumberFormat('es-CO', {
                                                                    style: 'currency',
                                                                    currency: 'COP',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                }).format(profitData.avgProfit)}
                                                            </motion.h4>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col sm={4}>
                                                    <div className="profit-stat-card">
                                                        <div className="profit-stat-icon">
                                                            <i className="fas fa-shopping-bag"></i>
                                                        </div>
                                                        <div className="profit-stat-content">
                                                            <p className="profit-stat-label">Ventas Totales</p>
                                                            <motion.h4 
                                                                className="profit-stat-value"
                                                                initial={{ opacity: 0, scale: 0.5 }}
                                                                animate={{ opacity: 1, scale: 1 }}
                                                                transition={{ duration: 0.5, delay: 1.4 }}
                                                            >
                                                                {profitData.totalSales}
                                                            </motion.h4>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>
                </Row>

                {/* Tarjeta de Utilidad por Mes */}
                <Row className="g-4 mt-4">
                    <Col xl={12}>
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.9 }}
                        >
                            <Card className="month-profit-card">
                                <Card.Body className="profit-body">
                                    <Row className="align-items-center">
                                        <Col md={3} className="text-center profit-icon-section">
                                            <motion.div
                                                className="profit-icon-container"
                                                animate={{ 
                                                    y: [0, -10, 0],
                                                }}
                                                transition={{ 
                                                    duration: 2.5,
                                                    repeat: Infinity,
                                                    ease: "easeInOut"
                                                }}
                                            >
                                                <i className="fas fa-calendar-alt profit-icon"></i>
                                            </motion.div>
                                            <h3 className="profit-label">Utilidad del Mes</h3>
                                            <p className="month-profit-date">
                                                {new Date(SelectedYear, parseInt(SelectedMonth) - 1).toLocaleDateString('es-CO', { month: 'long', year: 'numeric' })}
                                            </p>
                                        </Col>
                                        <Col md={9}>
                                            <Row className="g-3">
                                                <Col lg={3} sm={6}>
                                                    <div className="profit-stat-card">
                                                        <div className="profit-stat-icon">
                                                            <i className="fas fa-money-bill-wave"></i>
                                                        </div>
                                                        <div className="profit-stat-content">
                                                            <p className="profit-stat-label">Utilidad Total</p>
                                                            <motion.h4 
                                                                className="profit-stat-value"
                                                                initial={{ opacity: 0, scale: 0.5 }}
                                                                animate={{ opacity: 1, scale: 1 }}
                                                                transition={{ duration: 0.5, delay: 1.1 }}
                                                            >
                                                                {new Intl.NumberFormat('es-CO', {
                                                                    style: 'currency',
                                                                    currency: 'COP',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                }).format(monthProfitData.totalProfit)}
                                                            </motion.h4>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col lg={3} sm={6}>
                                                    <div className="profit-stat-card">
                                                        <div className="profit-stat-icon">
                                                            <i className="fas fa-shopping-cart"></i>
                                                        </div>
                                                        <div className="profit-stat-content">
                                                            <p className="profit-stat-label">Total Ventas</p>
                                                            <motion.h4 
                                                                className="profit-stat-value"
                                                                initial={{ opacity: 0, scale: 0.5 }}
                                                                animate={{ opacity: 1, scale: 1 }}
                                                                transition={{ duration: 0.5, delay: 1.2 }}
                                                            >
                                                                {monthProfitData.totalSales}
                                                            </motion.h4>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col lg={3} sm={6}>
                                                    <div className="profit-stat-card profit-stat-card-highlight">
                                                        <div className="profit-stat-icon">
                                                            <i className="fas fa-tag"></i>
                                                        </div>
                                                        <div className="profit-stat-content">
                                                            <p className="profit-stat-label">Por Venta</p>
                                                            <motion.h4 
                                                                className="profit-stat-value profit-stat-value-highlight"
                                                                initial={{ opacity: 0, scale: 0.5 }}
                                                                animate={{ opacity: 1, scale: 1 }}
                                                                transition={{ duration: 0.5, delay: 1.3 }}
                                                            >
                                                                {new Intl.NumberFormat('es-CO', {
                                                                    style: 'currency',
                                                                    currency: 'COP',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                }).format(monthProfitData.avgProfitPerSale)}
                                                            </motion.h4>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col lg={3} sm={6}>
                                                    <div className="profit-stat-card">
                                                        <div className="profit-stat-icon">
                                                            <i className="fas fa-calendar-day"></i>
                                                        </div>
                                                        <div className="profit-stat-content">
                                                            <p className="profit-stat-label">Por Día</p>
                                                            <motion.h4 
                                                                className="profit-stat-value"
                                                                initial={{ opacity: 0, scale: 0.5 }}
                                                                animate={{ opacity: 1, scale: 1 }}
                                                                transition={{ duration: 0.5, delay: 1.4 }}
                                                            >
                                                                {new Intl.NumberFormat('es-CO', {
                                                                    style: 'currency',
                                                                    currency: 'COP',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                }).format(monthProfitData.avgProfitPerDay)}
                                                            </motion.h4>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>
                </Row>

                {/* Sección Gastos del mes vs Utilidad neta */}
                <Row className="g-4 mt-2">
                    <Col xl={12}>
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 1 }}
                        >
                            <Card className="net-profit-card">
                                <Card.Header className="net-profit-card-header">
                                    <h5 className="net-profit-card-title">
                                        <i className="fas fa-balance-scale me-2"></i>
                                        Gastos del mes y utilidad neta
                                    </h5>
                                    <span className="net-profit-card-period">
                                        {new Date(SelectedYear, parseInt(SelectedMonth) - 1).toLocaleDateString('es-CO', { month: 'long', year: 'numeric' })}
                                    </span>
                                </Card.Header>
                                <Card.Body>
                                    <Row className="g-3">
                                        <Col md={4}>
                                            <div className="net-profit-stat net-profit-stat-expenses">
                                                <div className="net-profit-stat-icon">
                                                    <i className="fas fa-wallet"></i>
                                                </div>
                                                <div className="net-profit-stat-content">
                                                    <p className="net-profit-stat-label">Gastos del mes</p>
                                                    <h4 className="net-profit-stat-value">
                                                        {new Intl.NumberFormat('es-CO', {
                                                            style: 'currency',
                                                            currency: 'COP',
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        }).format(monthExpensesTotal)}
                                                    </h4>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="net-profit-stat net-profit-stat-utility">
                                                <div className="net-profit-stat-icon">
                                                    <i className="fas fa-chart-line"></i>
                                                </div>
                                                <div className="net-profit-stat-content">
                                                    <p className="net-profit-stat-label">Utilidad del mes</p>
                                                    <h4 className="net-profit-stat-value">
                                                        {new Intl.NumberFormat('es-CO', {
                                                            style: 'currency',
                                                            currency: 'COP',
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        }).format(monthProfitData.totalProfit)}
                                                    </h4>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className={`net-profit-stat net-profit-stat-net ${(monthProfitData.totalProfit - monthExpensesTotal) >= 0 ? 'net-profit-positive' : 'net-profit-negative'}`}>
                                                <div className="net-profit-stat-icon">
                                                    <i className="fas fa-piggy-bank"></i>
                                                </div>
                                                <div className="net-profit-stat-content">
                                                    <p className="net-profit-stat-label">Utilidad neta del mes</p>
                                                    <h4 className="net-profit-stat-value">
                                                        {new Intl.NumberFormat('es-CO', {
                                                            style: 'currency',
                                                            currency: 'COP',
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        }).format(monthProfitData.totalProfit - monthExpensesTotal)}
                                                    </h4>
                                                    <small className="net-profit-stat-desc">
                                                        Utilidad − Gastos
                                                    </small>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>
                </Row>

                {/* Gráfico Utilidad por Categoría del Mes */}
                <Row className="g-4 mt-2">
                    <Col xl={12}>
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 1.02 }}
                        >
                            <Card className="chart-card">
                                <Card.Header className="chart-header">
                                    <h5 className="chart-title">
                                        <i className="fas fa-chart-pie me-2"></i>
                                        Utilidad por Categoría
                                    </h5>
                                    <span className="chart-period">
                                        {new Date(SelectedYear, parseInt(SelectedMonth) - 1).toLocaleDateString('es-CO', { month: 'long', year: 'numeric' })}
                                    </span>
                                </Card.Header>
                                <Card.Body className="chart-body">
                                    <div className="chart-container" style={{ minHeight: '320px' }}>
                                        <Bar
                                            data={profitByCategoryData}
                                            options={{
                                                ...getChartOptions('Utilidad generada por cada categoría', 'bar'),
                                                indexAxis: 'y', // Barras horizontales
                                                plugins: {
                                                    ...getChartOptions('Utilidad generada por cada categoría', 'bar').plugins,
                                                    tooltip: {
                                                        backgroundColor: 'rgba(51, 46, 90, 0.9)',
                                                        titleColor: '#fff',
                                                        bodyColor: '#fff',
                                                        borderColor: brandColors.primary,
                                                        borderWidth: 1,
                                                        padding: 12,
                                                        callbacks: {
                                                            label: function(context) {
                                                                const value = context.parsed.x || 0;
                                                                return `Utilidad: ${new Intl.NumberFormat('es-CO', {
                                                                    style: 'currency',
                                                                    currency: 'COP',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                }).format(value)}`;
                                                            }
                                                        }
                                                    }
                                                },
                                                scales: {
                                                    x: {
                                                        beginAtZero: true,
                                                        ticks: {
                                                            callback: function(value) {
                                                                return new Intl.NumberFormat('es-CO', {
                                                                    style: 'currency',
                                                                    currency: 'COP',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0,
                                                                    notation: 'compact',
                                                                    compactDisplay: 'short'
                                                                }).format(value);
                                                            }
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>
                </Row>

                {/* Gráfico Utilidad bruta / Gastos / Utilidad neta */}
                <Row className="g-4 mt-2">
                    <Col xl={12}>
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 1.05 }}
                        >
                            <Card className="chart-card">
                                <Card.Header className="chart-header">
                                    <h5 className="chart-title">
                                        <i className="fas fa-chart-bar me-2"></i>
                                        Utilidad bruta, Utilidad neta, Ventas y Gastos por mes
                                    </h5>
                                    <span className="chart-period">
                                        Año {SelectedYear}
                                    </span>
                                </Card.Header>
                                <Card.Body className="chart-body">
                                    <div className="chart-container" style={{ minHeight: '280px' }}>
                                        <Line
                                            data={profitExpenseNetChartData}
                                            options={getChartOptions('Valor en $ por mes', 'line')}
                                        />
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>
                </Row>

                {/* Gráfico Utilidad por Categoría Mensual (Líneas) */}
                <Row className="g-4 mt-2">
                    <Col xl={12}>
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 1.08 }}
                        >
                            <Card className="chart-card">
                                <Card.Header className="chart-header">
                                    <h5 className="chart-title">
                                        <i className="fas fa-chart-line me-2"></i>
                                        Utilidad por Categoría - Evolución Mensual
                                    </h5>
                                    <span className="chart-period">
                                        Año {SelectedYear}
                                    </span>
                                </Card.Header>
                                <Card.Body className="chart-body">
                                    <div className="chart-container" style={{ minHeight: '350px' }}>
                                        <Line
                                            data={profitByCategoryMonthlyData}
                                            options={{
                                                ...getChartOptions('Utilidad mensual por categoría', 'line'),
                                                plugins: {
                                                    ...getChartOptions('Utilidad mensual por categoría', 'line').plugins,
                                                    legend: {
                                                        position: 'top',
                                                        labels: {
                                                            usePointStyle: true,
                                                            padding: 15,
                                                            font: {
                                                                size: 12,
                                                                weight: '600'
                                                            },
                                                            boxWidth: 12,
                                                            boxHeight: 12,
                                                        }
                                                    },
                                                    tooltip: {
                                                        backgroundColor: 'rgba(51, 46, 90, 0.95)',
                                                        titleColor: '#fff',
                                                        bodyColor: '#fff',
                                                        borderColor: brandColors.primary,
                                                        borderWidth: 1,
                                                        padding: 14,
                                                        titleFont: {
                                                            size: 14,
                                                            weight: 'bold'
                                                        },
                                                        bodyFont: {
                                                            size: 13
                                                        },
                                                        callbacks: {
                                                            label: function(context) {
                                                                const label = context.dataset.label || '';
                                                                const value = context.parsed.y || 0;
                                                                return `${label}: ${new Intl.NumberFormat('es-CO', {
                                                                    style: 'currency',
                                                                    currency: 'COP',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                }).format(value)}`;
                                                            }
                                                        }
                                                    }
                                                },
                                                scales: {
                                                    y: {
                                                        beginAtZero: true,
                                                        ticks: {
                                                            callback: function(value) {
                                                                return new Intl.NumberFormat('es-CO', {
                                                                    style: 'currency',
                                                                    currency: 'COP',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0,
                                                                    notation: 'compact',
                                                                    compactDisplay: 'short'
                                                                }).format(value);
                                                            }
                                                        }
                                                    },
                                                    x: {
                                                        grid: {
                                                            display: true,
                                                            color: 'rgba(51, 46, 90, 0.05)'
                                                        }
                                                    }
                                                },
                                                interaction: {
                                                    mode: 'index',
                                                    intersect: false,
                                                }
                                            }}
                                        />
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>
                </Row>

                 {/* Gráfico de Ventas por Categoría del Día */}
                <Row className="g-4 mt-2">
                    <Col xl={6} lg={12}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.6 }}
                        >
                            <Card className="chart-card">
                                <Card.Header className="chart-header">
                                    <h5 className="chart-title">
                                        <i className="fas fa-chart-column me-2"></i>
                                        Ventas por Categoría del Día
                                    </h5>
                                </Card.Header>
                                <Card.Body className="chart-body">
                                    <div className="chart-container">
                                        <Bar 
                                            data={todayCategoryData} 
                                            options={getChartOptions('Distribución de Ventas del Día por Categoría')} 
                                        />
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>

                    {/* Top Producto del Día */}
                    <Col xl={6} lg={12}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.7 }}
                        >
                            <Card className="chart-card top-product-card">
                                <Card.Header className="chart-header">
                                    <h5 className="chart-title">
                                        <i className="fas fa-trophy me-2"></i>
                                        Producto Más Vendido del Día
                                    </h5>
                                </Card.Header>
                                <Card.Body className="chart-body">
                                    <div className="top-product-content">
                                        <motion.div 
                                            className="top-product-icon"
                                            animate={{ 
                                                rotate: [0, 10, -10, 10, 0],
                                                scale: [1, 1.1, 1, 1.1, 1]
                                            }}
                                            transition={{ 
                                                duration: 2,
                                                repeat: Infinity,
                                                repeatDelay: 3
                                            }}
                                        >
                                            <i className="fas fa-medal"></i>
                                        </motion.div>
                                        <motion.h3 
                                            className="top-product-name"
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.6, delay: 0.8 }}
                                        >
                                            {kpiData.topProducto || 'Sin datos disponibles'}
                                        </motion.h3>
                                        <p className="top-product-subtitle">
                                            ¡El favorito de hoy! 🎉
                                        </p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>
                </Row>

            
                {/* Gráficos Principales */}
                <Row className="g-4 mt-2">
                    {/* Ventas Anuales */}
                    <Col xl={6} lg={12}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                        >
                            <Card className="chart-card">
                                <Card.Header className="chart-header">
                                    <h5 className="chart-title">
                                        <i className="fas fa-chart-bar me-2"></i>
                                        Ventas vs Gastos Anuales
                                    </h5>
                                </Card.Header>
                                <Card.Body className="chart-body">
                                    <div className="chart-container">
                                        <Bar data={salesData} options={getChartOptions('Ventas vs Gastos por Mes')} />
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>

                    {/* Ventas Diarias */}
                    <Col xl={6} lg={12}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.3 }}
                        >
                            <Card className="chart-card">
                                <Card.Header className="chart-header">
                                    <h5 className="chart-title">
                                        <i className="fas fa-chart-line me-2"></i>
                                        Ventas vs Gastos Diarios
                                    </h5>
                                </Card.Header>
                                <Card.Body className="chart-body">
                                    <div className="chart-container">
                                        <Line data={salesDataDay} options={getChartOptions('Ventas vs Gastos por Día', 'line')} />
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>

                    {/* Ventas por Categoría */}
                    <Col xl={6} lg={12}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.4 }}
                        >
                            <Card className="chart-card">
                                <Card.Header className="chart-header">
                                    <h5 className="chart-title">
                                        <i className="fas fa-tags me-2"></i>
                                        Ventas por Categoría
                                    </h5>
                                </Card.Header>
                                <Card.Body className="chart-body">
                                    <div className="chart-container">
                                        <Bar data={salesDataCategory} options={getHorizontalBarOptions('Ventas por Categoría')} />
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>

                    {/* Gastos por Categoría */}
                    <Col xl={6} lg={12}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.5 }}
                        >
                            <Card className="chart-card">
                                <Card.Header className="chart-header">
                                    <h5 className="chart-title">
                                        <i className="fas fa-receipt me-2"></i>
                                        Gastos por Categoría
                                    </h5>
                                </Card.Header>
                                <Card.Body className="chart-body">
                                    <div className="chart-container">
                                        <Bar data={expensesDataCategory} options={getHorizontalBarOptions('Gastos por Categoría')} />
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>

                    {/* Productos más Vendidos */}
                    <Col xl={12} lg={12}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.6 }}
                        >
                            <Card className="chart-card">
                                <Card.Header className="chart-header">
                                    <h5 className="chart-title">
                                        <i className="fas fa-shopping-basket me-2"></i>
                                        Productos más Vendidos
                                    </h5>
                                </Card.Header>
                                <Card.Body className="chart-body">
                                    <div className="chart-container-large">
                                        <Bar data={salesDataItemsFood} options={getHorizontalBarOptions('Productos más Vendidos')} />
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>

                    {/* Ventas de Grooming por Mes */}
                    <Col xl={12} lg={12}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.7 }}
                        >
                            <Card className="chart-card">
                                <Card.Header className="chart-header">
                                    <h5 className="chart-title">
                                        <i className="fas fa-cut me-2"></i>
                                        Ventas de Grooming por Mes
                                    </h5>
                                </Card.Header>
                                <Card.Body className="chart-body">
                                    <div className="chart-container-large">
                                        <Bar 
                                            data={groomingData} 
                                            options={getChartOptions('Ventas de Grooming por Mes')} 
                                        />
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ModernDashboard;
